'use strict';
import angular from 'angular';
import $ from 'jquery';
import _ from 'lodash';

import dateRulesHtmlUrl from '../views/dateRules.html';
import recalculateAllHtmlUrl from '../views/recalculateAll.html';
import showRecalculateResultsHtmlUrl from '../views/showRecalculateResults.html';
import newFieldHtmlUrl  from '../../../views/shared/addField.html';

angular.module('products.ctrls', [])
    .controller('ProductsController', ProductsController)
    .controller('ViewProductGroupsController', ViewProductGroupsController)
    .controller('ProductLookupController', ProductLookupController)
    .controller('DateRulesController', DateRulesController)
    .controller('RecalculateAllController', RecalculateAllController)
    .controller('ShowRecalculateResultsController', ShowRecalculateResultsController)
    .controller('ProductFlightsController', ProductFlightsController);

ProductsController.$inject = ['$scope', '$rootScope', 'ProductService', 'OrdersService', 'UserService', '$state', '$ioAlert', '$modal', 'ClusterService', 'DateRangeService', 'ModalService', 'ProductCategoriesService', 'ClientMappingService', 'anchorSmoothScroll', '$location', '$timeout', 'FormService', 'DashboardsDataPublisherHelper'];

function ProductsController($scope, $rootScope, ProductService, OrdersService, UserService, $state, $ioAlert, $modal, ClusterService, DateRangeService, ModalService, ProductCategoriesService, ClientMappingService, anchorSmoothScroll, $location, $timeout, FormService, DashboardsDataPublisherHelper) {
    $scope.products = [];
    $scope.loadFail = false;
    $scope.disableBtnAction = false;
    $scope.flightTimeFrames = [
        {"id": "weekly", "name": 'Weekly'},
        {"id": "monthly", "name": 'Monthly'}
    ];
    $scope.monthlyFlightStartOnValues = [
        {"id": "line_item_start", "name": 'Line Item Start'},
        {"id": "first_day_of_month", "name": 'First Day of the Month'}
    ];
    $scope.weeklyFlightStartDaysOfWeek = [
        {"id": "monday", "name": 'Monday'},
        {"id": "tuesday", "name": 'Tuesday'},
        {"id": "wednesday", "name": 'Wednesday'},
        {"id": "thursday", "name": 'Thursday'},
        {"id": "friday", "name": 'Friday'},
        {"id": "saturday", "name": 'Saturday'},
        {"id": "sunday", "name": 'Sunday'}
    ];

    var clusterSelector = $rootScope.$on('ClusterChanged', function(event, args) {
        $scope.getProducts();
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    $scope.getProducts = function() {
        $scope.products = [];
        $rootScope.loadingInProgress = true;
        $rootScope.loadertitle = "Fetching Products";
        ProductService.getProducts(ClusterService.clusterIds[0], true).then(function(success) {
            $scope.products = ProductService.products;
            $scope.productsLoader = false;
            $rootScope.loadingInProgress = false;
        }, function(error) {
            $scope.productsLoader = false;
            $rootScope.loadingInProgress = false;
        });
    };

    var getPushEnabledServices = function() {
        ClientMappingService.getPushServices().then(function(response) {
            if (response && response.services) {
                $scope.pushEnabledServices = response.services;
            }
        }, function(error) {

        })
    }

    var getTAServices = function() {
        ProductService.getTAServices().then(function(response) {
            if (response && response.data) {
                $scope.TAServices = response.data;
            }
        }, function(error) {

        })
    }

    var getTemplateTypes = function() {
        ProductService.getTemplateTypes().then(function(response) {
            $scope.templateTypes = response;
        }, function(error) {

        });
    }

    $scope.editProduct = function(product) {
        if (product) {
            $scope.addProduct(product)
        } else {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        }
    };

    $scope.showProductCategories = function() {
        $state.go('productCategories', {});
    };

    $scope.getProductCategories = function() {
        ProductCategoriesService.getCategories().then(function(success) {
            $scope.productCategories = success[0].productCategories;
        }, function(error) {
            $ioAlert.show('Error!', 'Could not retrieve product categories.', 'error');
        });
    };

    $scope.addProduct = function(product) {
        let isNew = true;
        if (product) {
            isNew = false;
        }
        let modalObj = $modal.open(
            ModalService.returnModalType('createProduct', {
                data: {
                    product: product,
                    clusters: ClusterService.clusters,
                    productCategories: $scope.productCategories,
                    pushEnabledServices: $scope.pushEnabledServices,
                    TAServices: $scope.TAServices,
                    flightTimeFrames: $scope.flightTimeFrames,
                    monthlyFlightStartOnValues: $scope.monthlyFlightStartOnValues,
                    weeklyFlightStartDaysOfWeek: $scope.weeklyFlightStartDaysOfWeek,
                    orderTypes: $scope.orderTypes,
                }
            })
        );

        modalObj.result.then(function(formObj) {
            if (formObj.active) {
                formObj.active = 'yes';
            } else {
                formObj.active = 'no';
            }
            if (formObj.bookable) {
                formObj.bookable = 'yes';
            } else {
                formObj.bookable = 'no';
            }

            if (formObj.enableFlights) {
                formObj.enableFlights = 'yes';
            } else {
                formObj.enableFlights = 'no';
            }

            if (formObj.flightAutoCreateTimeframe == undefined) {
                formObj.monthlyFlightStartOn = undefined;
                formObj.weeklyFlightStartOn = undefined;
            }

            if (formObj.useFlightsAsPlacements) {
                formObj.useFlightsAsPlacements = 'yes';
            } else {
                formObj.useFlightsAsPlacements = 'no';
            }

            if (formObj.multipleMapping) {
                formObj.multipleMapping = 'yes';
            } else {
                formObj.multipleMapping = 'no';
            }

            if (isNew) {
                ProductService.saveProduct(formObj).then(function(data) {
                    let product = data ? data.product : undefined;
                    if(product?.cluster_ids.length > 0) {
                        // indexOf is working, the reason is that ClusterService.clusterIds[0] is string
                        // the ids in product.cluster_ids are numbers
                        if(product.cluster_ids.includes(parseInt(ClusterService.clusterIds[0])) ||
                            ClusterService.clusterIds[0] == 0 ||
                            product.cluster_ids[0] == 0
                        ) {
                            $scope.products.push(product);
                            $ioAlert.show('', 'Product created successfully', 'success');
                            $location.hash('bottom-scroll');
                            anchorSmoothScroll.scrollTo('bottom-scroll');
                            $timeout(function() {
                                $location.hash('');
                            }, 1000);
                        } else {
                            $ioAlert.show('', 'Product created for other Business Units successfully', 'success');
                        }
                        $scope.productsLoader = false;
                    } else {
                        console.log("Error adding product");
                        $ioAlert.show('', 'Failed to add a product', 'error');
                        $scope.productsLoader = false;
                    }
                }, function(error) {
                    console.log("Error adding product");
                    $ioAlert.show('', error, 'error');
                    $scope.productsLoader = false;
                });
            } else {
                ProductService.updateProduct(formObj).then(function(data) {
                    if (data.errors) {
                        $ioAlert.show('', data.errors[0], 'error');
                    } else {
                        let product = data ? data.product : undefined;
                        if(product?.cluster_ids.length > 0) {
                            // indexOf is working, the reason is that ClusterService.clusterIds[0] is string
                            // the ids in product.cluster_ids are numbers, have to convert cluster ids from
                            // integer to string. Because ClusterService.clusterIds are string, cluster_ids of
                            // a product in the product list are also string
                            product.cluster_ids = product.cluster_ids.map((cluster_id) => String(cluster_id));
                            if(product.cluster_ids.includes(ClusterService.clusterIds[0]) ||
                                ClusterService.clusterIds[0] == 0 ||
                                product.cluster_ids[0] == 0
                            ) {
                                for (let i = 0, len = $scope.products.length; i < len; i++) {
                                    if ($scope.products[i].id == data.product.id) {
                                        $scope.products[i] = data.product;
                                    }
                                }
                            } else {
                                for (let i = 0, len = $scope.products.length; i < len; i++) {
                                    if ($scope.products[i].id == data.product.id) {
                                        $scope.products.splice(i, 1);
                                        break;
                                    }
                                }
                            }
                            $ioAlert.show('', 'Product updated successfully', 'success');
                        } else {
                            console.log("Error updating product");
                            $ioAlert.show('', 'Failed to update a product', 'error');
                            $scope.productsLoader = false;
                        }
                    }
                }, function(error) {
                    $ioAlert.show('Error!', error, 'error');
                    $scope.productsLoader = false;
                });
            }
        }, function(cancel) {});
    };

    $scope.viewLookups = function(product) {
        if (product && product.id) {
            $state.go('productLookup', {
                id: product.id
            });
        } else {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        }
    };

    $scope.viewFlights = function(product) {
        if (product && product.id) {
            $state.go('productFlights', {
                id: product.id,
                "productName": product.name,
                "flightFormId" : product.flight_form_id

            });
        } else {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        }
    };

    $scope.viewProductGroups = function(product) {
        if (product && product.id) {
            $state.go('viewProductGroups', {
                id: product.id,
                product: product
            });
        } else {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        }
    };

    $scope.createFormTemplate = function() {
        $modal.open(
            ModalService.returnModalType('createFormTemplate', {
                data: {
                    templateTypes: $scope.templateTypes,
                    clusters: ClusterService.clusters
                }
            })
        ).result.then(function() {
            $scope.getProducts();
        });
    }

    //Clone all product lookup content
    $scope.cloneAllProductLookupContent = function() {
        if (!ClusterService.clusterIds.length || ClusterService.clusterIds[0] == 0) {
            $ioAlert.show('', 'You must select a business unit to continue.', 'error');
        } else {
            /* common modal service for cloneAllProductLookupContent*/
            const modalObj = $modal.open(
                ModalService.returnModalType('lookupContentForClusterClone', {
                    data: {
                        clusters: ClusterService.clusters
                    }
                })
            );
            modalObj.result.then(function(formObj) {
                ProductService.cloneAllProductLookupContentForClusters(formObj.sourceClusterId, formObj.destClusterIds).then(function(data) {
                    if (data.errors) {
                        $ioAlert.show('', data.errors[0], 'error');
                    } else if (data.dest_cluster_ids) {
                        $ioAlert.show('', 'Lookup content cloned successfully', 'success');
                    } else {
                        $ioAlert.show('', 'An error occurred cloning lookup content.', 'error');
                    }
                }, function(error) {
                    $ioAlert.show('', 'An error occurred cloning lookup content.', 'error');
                });
            }, function(cancel) {});
        }
    };

    $scope.publishToDashboards = function() {
        DashboardsDataPublisherHelper.publishData()
    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    $scope.importProduct = function() {
        if (!$scope.disableBtnAction && $scope.uploadMedia.file && $scope.uploadMedia.file.length) {
            $ioAlert.show('', 'File is being uploaded, please do not refresh the page', 'success');
            ProductService.importProduct($scope.uploadMedia.file).then(function(response) {
                if (response.errors) {
                    for (var i = 0, len = response.errors.length; i < len; i++) {
                        $ioAlert.show('ERROR!', response.errors[i], 'error');
                    }
                    console.log(response.errors);
                } else {
                    $ioAlert.show('', 'File Imported successfully', 'success');
                    $scope.getProducts();
                }

            }, function(errors) {
                for (let i = 0, len = errors.length; i < len; i++) {
                    $ioAlert.show('ERROR!', errors[i], 'error');
                }
                console.log("Error importing product: " + errors);
            });
        } else {
            //$ioAlert.show("Error!", "Upload at least one file", 'error');
        }
    };

    $scope.exportProduct = function(productId) {
        ProductService.exportProduct(productId).then(function(response) {
            let errors = response.data.errors;
            if (errors) {
                $ioAlert.show('', 'An error occurred exporting product: ' + errors[0], 'error');
                console.log(errors);
            } else {
                var csvString = response.data;
                var a = $('<a/>', {
                    style: 'display:none',
                    href: 'data:application/octet-stream;base64,' + btoa(unescape(encodeURIComponent(csvString))),
                    download: 'product_' + productId + '.csv'
                }).appendTo('body');
                a[0].click();
                a.remove();
            }
        }, function(error) {
            $ioAlert.show('', 'An error occurred exporting product.', 'error');
            console.log(error);
        });
    };

    var getOrderTypes = function() {
        OrdersService.getOrderTypes().then(function(types) {
            $scope.orderTypes = types;
        }, function(error) {
            console.log("error loading order types");
        });
    };

    var init = function() {
        $scope.productsLoader = true;
        ClusterService.initCluster($rootScope.userRole);
        DateRangeService.init();
        $scope.getProductCategories();
        getPushEnabledServices();
        getTAServices();
        getTemplateTypes();
        getOrderTypes();
        UserService.adjustStickyHeader();
        getInstanceLockConfig();
    };

    if ($rootScope.userRole && $rootScope.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rootScope.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
    UserService.adjustStickyHeaderWindowResize();
}

ViewProductGroupsController.$inject = ['$scope', '$rootScope', '$stateParams', '$state', '$ioAlert', '$confirm', 'UserService', 'ProductService', '$modal', 'FormService', 'ModalService', '$filter', 'anchorSmoothScroll', '$location', '$timeout', 'ClusterService', 'WorkflowsService'];

    function ViewProductGroupsController($scope, $rootScope, $stateParams, $state, $ioAlert, $confirm, UserService, ProductService, $modal, FormService, ModalService, $filter, anchorSmoothScroll, $location, $timeout, ClusterService, WorkflowsService) {
        const FIELD_MAX_LENGTH = 44;
        let date_moment_tool = require('moment-business-days');

        $scope.productId = $stateParams.id;
        $scope.productFieldObj = [];
        $scope.productFields = [];
        $scope.activeProductFields = [];
        $scope.productFilterObj = [];
        $scope.productGroups = [];
        $scope.groupNames = [];  // For use by add/edit field modal
        $scope.displayGroups = [];
        $scope.showActiveGroup = true;
        $scope.sortableIconShowHide = true;
        $scope.showSynchronized = false;
        $scope.sortableDragIconShowHide = [];
        $scope.showForm = false;
        $scope.isDisabled = false;
        $scope.rollupTargetFieldNames = [];
        $scope.workflowActions = [];
        $scope.defaultValueDisabled = true;
        $scope.defaultValueType = 'text';
        $scope.defaultInputType = 'text';
        $scope.defaultValuePrevType = '';
        $scope.defaultLookupContents = [];
        $scope.disableDisplayOrder = false;
        $scope.selectedRow = null;
        $scope.fieldHeaderName ="Add Field";
        $scope.hideEditProductGroupName = [];
        $scope.oldvalue = {};
        var highlightedField = {};
        $scope.clusterId = null;
        $scope.modalShown = false;
        $scope.toggleModal = function() {
            $scope.modalShown = !$scope.modalShown;
        };
        $scope.showActive = true;
        $scope.disableBtnAction = false;
        $scope.showLookupType = true;
        $scope.fieldsTableData = [{
            "name": "Id",
            "value": "id",
            "id": true
        }, {
            "name": "Field Name",
            "value": "field_name",
            "id": true
        },
         {
            "name": "Display Name",
            "value": "display_name",
            "id": true
        },
         {
            "name": "Data Type",
            "value": "data_type",
            "id": true
        },
         {
            "name": "Input Type",
            "value": "input_type_name",
            "id": true
        }, {
            "name": "Cascading Field Name",
            "value": "cascading_field_name",
            "id": true
        }, {
            "name": "Parent",
            "value": "parent_name",
            "id": true
        }, {
            "name": "Parent Trigger",
            "value": "parent_trigger_name",
            "id": true
        }, {
            "name": "Lookup Type Id",
            "value": "lookup_type_id",
            "id": true
        }, {
            "name": "Default Value",
            "value": "default_value",
            "id": true
        }, {
            "name": "Required",
            "value": "required",
            "id": true
        }, {
            "name": 'Show Long Text',
            "value": 'show_long_text',
             "id": true
        },{
            "name": 'Type ahead',
            "value": 'enable_type_ahead',
             "id": true
        }, {
            "name": "Show in Dashboards",
            "value": "dashboard_enabled",
            "id": true
        }, {
            "name": "Grid Show",
            "value": "grid_show",
            "id": false,
        }, {
            "name": "Active",
            "value": "active",
            "id": false,
        }, {
            "name": "Help Text",
            "value": "help_text",
            "id": true
        }, {
            "name": "Formula",
            "value": "formula",
            "id": true
        }, {
            "name": "Validation Rules",
            "value": "validation_rules",
            "id": true
        },{
            "name": "Goal Association",
            "value": "goal_association",
            "id": true
        },{
            "name": "Rollup Field Name",
            "value": "rollup_field_name",
            "id": true
        },{
            "name": "Custom Edit Action",
            "value": "custom_edit_action_name",
            "id": false
        }];

    $scope.fieldsHeader = {};
    $scope.tbsortableOptions = {};
    $scope.fieldTemplate = newFieldHtmlUrl;
    $scope.showParentMultiSelect = true;
    $scope.inputTypesList = [];
    $scope.editableEnum = [
        {"label": "Editable", "value": 'enable'},
        {"label": "Add Only", "value": 'add'},
        {"label": "Edit Only", "value": 'edit'},
        {"label": "Not Editable", "value": 'disable'}
    ];
    $scope.defaultDateOptions = [
        "Today",
        "Tomorrow",
        "Yesterday",
        "Next week",
        "Next month",
    ];
    $scope.dateOffset = 0;
    $scope.willExpandAllGroups = true;
    $scope.isExpandCollapseButtonDisabled = true;

    $scope.resetParentId = function() {
        $scope.fieldsObj.parentId = undefined;
        $scope.showParentMultiSelect = true;
    }

    var clusterSelector = $rootScope.$on('ClusterChanged', function() {
        $scope.clusterId = ClusterService.clusterIds[0];
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });
    
    $scope.enableEditProductGroupName = function(groupId) {
        $scope.hideEditProductGroupName[groupId] = true;
    }
    $scope.cancelEditProductGroupName = function(groupId) {
        $scope.hideEditProductGroupName[groupId] = false;
    }
    
    $scope.disableEditProductGroupName = function(groupId, groupObj) {
       
        if(groupObj.group_name.length === 0){
            $ioAlert.show('Error', 'Group Name Can not be empty.', 'error');
           
            $scope.hideEditProductGroupName[groupId] = true;
        } else if(groupObj.group_name.includes('Buy')) {
            $ioAlert.show('Error', 'Product Group name cannot include \'Buy\'', 'error');
            $scope.hideEditProductGroupName[groupId] = true;
        } else {
            if($scope.oldvalue[groupObj.id] !== groupObj.group_name){
                $scope.hideEditProductGroupName[groupId] = false;
                var param = {};
                param.productId = groupObj.product_id;
                param.groupName = groupObj.group_name;
                param.groupDisplayOrder = groupObj.group_display_order;
                param.hideForCondition = groupObj.hide_for_condition;
                param.active = groupObj.active;
                param.id = groupObj.id;
                $scope.oldvalue[groupObj.id] = groupObj.group_name;
                ProductService.updateProductGroups(param).then(function(data) {
                    $ioAlert.show('Success', 'Product Group updated successfully', 'success');
                }, function(error) {
                    $ioAlert.show('Error', 'Error updating Product Group', 'error');
                });
            }
         }
    }

    //handle Product Group  Active and Inactive
    $scope.productGroupActiveChange = function(groupObj, $event) {
        $event.preventDefault();
        $event.stopPropagation();
        if (groupObj) {
            var text = '';
            if (groupObj.active === true) {
                text = 'Are you sure you want to disable this product group?';
            } else {
                text = 'Are you sure you want to enable this product group?';
            }
            $confirm.open({
                size: 'sm',
                text: text
            }).then(function() {
                groupObj.active = (groupObj.active == true) ? false : true;
                updateProductsGroup(groupObj);
            }, function() {
                console.log("cancel")
            });
        }
    }

    var updateDisplayGroups = function() {
        $scope.displayGroups = [];
        _.each($scope.productGroups, function (groupObj) {
            (groupObj.active == true) ? $scope.displayGroups.push(groupObj) : '';
        });
        $scope.displayGroups = $scope.showActiveGroup == true ? $scope.displayGroups : $scope.productGroups;
        $scope.groupNames = $scope.productGroups;
    }
  
    // Updating Product Group
    const updateProductsGroup = function (groupObj) {
        let param = {};
        param.id = groupObj.id;
        param.productId = groupObj.product_id;
        param.groupName = groupObj.group_name;
        param.groupDisplayOrder = groupObj.group_display_order;
        param.hideForCondition = groupObj.hide_for_condition;
        param.active = (groupObj.active === true || groupObj.active == '1') ? '1' : '0';
        ProductService.updateProductGroups(param).then(function (data) {
            if (data.errors) {
                groupObj.active = (groupObj.active == true) ? false : true;
                $ioAlert.show('', data.errors[0], 'error');
            } else {
                if (data.productFieldGroup && data.productFieldGroup.id) {
                    data.productFieldGroup.active = (data.productFieldGroup.active == '1');
                    for (let i = 0, len = $scope.productGroups.length; i < len; i++) {
                        if ($scope.productGroups[i].id == data.productFieldGroup.id) {
                            $scope.productGroups[i] = data.productFieldGroup;
                            break;
                        }
                    }
                    updateDisplayGroups();
                    $ioAlert.show('', 'Updated Successfully', 'success');
                }
            }
        }, function (error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    $scope.iosortableOptions = {
        handle: '.handle',
        stop: function(e, ui) {
            for (var group in $scope.displayGroups) {
                $scope.displayGroups[group].group_display_order = Number(group) + 1;
            }

            _.each($scope.displayGroups, function(groupObj, index) {
                if (groupObj.active == true) {
                    var param = {};
                    param.productId = groupObj.product_id;
                    param.groupName = groupObj.group_name;
                    param.groupDisplayOrder = groupObj.group_display_order;
                    param.active = groupObj.active;
                    param.id = groupObj.id;
                    param.hideForCondition = groupObj.hide_for_condition;
                    ProductService.updateProductGroups(param).then(function(data) {
                        if (index + 1 == $scope.displayGroups.length) {
                            $ioAlert.show('Success', 'Display Order updated successfully', 'success');
                        }

                    }, function(error) {
                        $ioAlert.show('Error', 'Error updating Display Order', 'error');
                    });
                }
            });
        }
    }

    const getProductGroups = function() {
        $rootScope.loadingInProgress = true;
        $rootScope.loadertitle = "Fetching Product Groups";
        ProductService.getProductFieldGroupsForDisplay($scope.productId).then(function(success) {
            $scope.productGroups = ProductService.productFieldGroups;
            $scope.displayGroups = [];
            _.each($scope.productGroups, function(groupObj){
                $scope.oldvalue[groupObj.id] = groupObj.group_name;
                groupObj.active = (groupObj.active == "1")?true:false;
                (groupObj.active == true) ? $scope.displayGroups.push(groupObj) : '';
            });
            $scope.displayGroups = $scope.showActiveGroup == true ? $scope.displayGroups : $scope.productGroups;
            $scope.groupNames = $scope.productGroups;
            getProductFields();
            $scope.isExpandCollapseButtonDisabled = $scope.productGroups.length === 0;
            $rootScope.loadingInProgress = false;
        }, function(error) {
            console.log("error loading form for product: ");
            $rootScope.loadingInProgress = false;
        });
    };

    var getOrderTypes = function() {
        OrderService.getOrderTypes().then(function(types) {
            $scope.orderTypes = types;
        }, function(error) {
            console.log("error loading order types");
        });
    };

    var getRoleTypes = function() {
        UserService.getRoleTypes().then(function(types) {
            $scope.roleTypes = types;
        }, function(error) {
            console.log("error loading role types");
        });
    };

    var getHideConditionTypes = function () {
        $scope.hideConditionTypes = [];
        $scope.hideConditionTypes.push('Role Type');
        getRoleTypes();
    };

    $scope.filterProductGroupsActiveColumn = function() {
        $scope.showActiveGroup = !$scope.showActiveGroup;
        $scope.sortableIconShowHide = $scope.showActiveGroup;
        updateDisplayGroups();
    }


    $scope.updateProductsHideCondition = function (group){
        showGroupModal('updateProductsHideConditionForm', {
            group: group,
            allGroups: $scope.productGroups,
            hideConditionTypes: $scope.hideConditionTypes,
            roleTypes: $scope.roleTypes,
            orderTypes: $scope.orderTypes,
        }).result.then(function(formObj) {
            if (formObj.hideForCondition?.length > 0) {
                group.hide_for_condition = {
                    "type": formObj.hideForConditionType,
                    "id": formObj.hideForCondition.toString()
                };
            } else {
                group.hide_for_condition = undefined;
            }
            group.hide_for_condition = JSON.stringify(group.hide_for_condition);
            updateProductsGroup(group);
        }, function(error) {
            console.log("modal dismissed");
        })
    
};
    /*
     * Handle add date rule
     */
    $scope.showDateRules = function() {
        if (haveStartEndDates()) {
            $modal.open({
                controller: 'DateRulesController',
                templateUrl: dateRulesHtmlUrl,
                resolve: {
                    productFields: function() {
                        return $scope.productFields;
                    },
                    level: function() {
                        return 'product';
                    }
                },
                backdrop: 'static'
            }).result.then(function(dateRulesObj) {
                _.each($scope.productFields, function(fieldObj) {
                    if (fieldObj.field_name == 'start_date') {
                        updateFormFieldDateRule(fieldObj, dateRulesObj.startDate);
                    } else if (fieldObj.field_name == 'end_date') {
                        updateFormFieldDateRule(fieldObj, dateRulesObj.endDate);
                    }
                });
            }, function(cancel) {
            });
        } else {
            $ioAlert.show('Error!', 'You must add "start_date" and "end_date" fields before configuring date rules', 'error');
        }
    }

    $scope.recalculateAll = function() {
        // We really would need the product, but a product field does the job too, and that's what the backend already
        // does.  If we get here, we have at least one calculateFields, so use the first one, it's as good as any.
        ProductService.lineItemIdsUsingProductField($scope.calculateFields[0].id).then(function(data) {
            if (data && data.id_list) {
                if (data.id_list.length == 0) {
                    $ioAlert.show('Error', 'There are no line items using this product', 'error');
                } else {
                    recalculateAllExec(data.id_list);
                }
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Could not fetch the list of line item ids using this product', 'error');
        });
    }

    let recalculateAllExec = function(idList) {
        $modal.open({
            controller: 'RecalculateAllController',
            templateUrl: recalculateAllHtmlUrl,
            resolve: {
                calculateFields: function() {
                    return $scope.calculateFields
                },
                targetEntity: function() {
                    return 'line item'
                },
                idList: function() {
                    return idList
                }
            },
            backdrop: 'static'
        }).result.then(function(recalculateAllObj) {
            ProductService.recalculateAll(recalculateAllObj.fieldId).then(function(data) {
                if (data) {
                    showRecalculateResults(data);
                } else {
                    $ioAlert.show('Error', 'Error recalculating attributes', 'error');
                }
            }, function(error) {
                console.log("Error recalculating attributes");
                $ioAlert.show('Error', 'Error recalculating attributes', 'error');
            });
            }, function(cancel) {
        });
    }

    let showRecalculateResults = function(results) {
        $modal.open({
            controller: 'ShowRecalculateResultsController',
            templateUrl: showRecalculateResultsHtmlUrl,
            resolve: {
                results: function() {
                    return results
                },
                targetEntity: function() {
                    return 'line item'
                }
            },
            backdrop: 'static'
        }).result.then(function(ok) {
        }, function(cancel) {
        });
    }

    var haveStartEndDates = function() {
        var hasStartDate = false;
        var hasEndDate = false;
        _.each($scope.productFields, function(fieldObj) {
            if (fieldObj.field_name == 'start_date') {
                hasStartDate = true;
            } else if (fieldObj.field_name == 'end_date') {
                hasEndDate = true;
            }
        });
        return (hasStartDate && hasEndDate);
    }

    var updateFormFieldDateRule = function(fieldObj, dateRuleObj) {
        var params = {};
        params.id = fieldObj.id;
        params.active = (fieldObj.active == "1") ? 'yes' : 'no';
        params.contentTypeId = fieldObj.content_type_id;
        params.dashboardEnabled = (fieldObj.dashboard_enabled == "1") ? 'yes' : 'no';
        params.dataType = fieldObj.data_type;
        params.dateRules = dateRuleObj.numDays ? JSON.stringify(dateRuleObj) : '';
        params.defaultValue = fieldObj.default_value;
        params.displayName = fieldObj.display_name;
        params.displayOrder = fieldObj.display_order;
        params.fieldName = fieldObj.field_name;
        params.formula = fieldObj.formula;
        params.gridShow = (fieldObj.grid_show == "1") ? 'yes' : 'no';
        params.groupId = fieldObj.group_id;
        params.hasDateRules = dateRuleObj.numDays ? 1 : 0;
        params.helpText = fieldObj.help_text;
        params.inputType = fieldObj.input_type;
        params.lookupTypeId = fieldObj.lookup_type_id;
        params.parentId = fieldObj.parent_id;
        params.parentTriggerId = fieldObj.parent_trigger_id;
        params.referenceId = fieldObj.reference_id;
        params.required = (fieldObj.required == "1") ? "yes" : "no";
        params.showLongText = (fieldObj.show_long_text == "1") ? 1 : 0;
        params.enableTypeAhead = (fieldObj.enable_type_ahead == "1") ? 1 : 0;
        params.validationRules = fieldObj.validation_rules;
        params.goalAssociation = fieldObj.goal_association;
        params.rollupFieldName = fieldObj.rollup_field_name;
        params.customEditAction = fieldObj.custom_edit_action_id;
        params.updateDateRule = 'yes';
        params.productId = fieldObj.product_id;

        ProductService.updateProductField(params).then(function(productField) {
            if (productField) {
                for (var i = 0, len = $scope.productFields.length; i < len; i++) {
                    if (productField.id == $scope.productFields[i].id) {
                        $scope.productFields[i] = productField;
                        break;
                    }
                }
                if (productField.field_name == "end_date") {
                    $ioAlert.show('Success', 'Date Rules updated successfully', 'success');
                }
                fieldsHelper();
            }
        }, function() {
            console.log("error saving form");
            $scope.productLoader = false;
        });
    }

    //Get Product field for a product id
    var getProductFields = function() {
        ProductService.getProductFieldsForDisplay($scope.productId, true).then(function(productName) {
            if (ProductService.productFields) {
                $scope.productFields = ProductService.productFields;
                fieldsHelper();
                $scope.activeProductFields = $scope.productFields.filter(field => field.active == 1);
                $scope.activeProductFields = _.orderBy($scope.activeProductFields, (item) => item.field_name.toLowerCase());

                var otherDates = $scope.activeProductFields.filter(field => field.data_type == "date")
                    .map(field => (field.field_name));
                $scope.defaultDateOptions.push.apply($scope.defaultDateOptions, otherDates);
            } else {
                $scope.productFields = [];
            }
            $scope.productName = productName;
        }, function(error) {
            console.log("error loading form for product");
        });
    };

    var getLookupTypes = function() {
        ProductService.getLookupTypes().then(function(success) {
            $scope.lookUpTypes = _.orderBy(ProductService.lookupTypes, (item) => item.name.toLowerCase());
        }, function(error) {
            console.log("error loading lookup types");
        });
    };

    var getDataTypes = function() {
        FormService.getDataTypes().then(function(data) {
            $scope.dataTypes = data.sort();
        }, function(error) {
            console.log("error loading data types");
        })
    };

    var getInputTypes = function() {
        FormService.getInputTypes().then(function(data) {
            $scope.inputTypesList = data;
            var inputTypes = [];
            $scope.inputTypes = [];
            _.each(data, function(label, key){
                inputTypes.push({key: key, label: label});
            });
            inputTypes = _.sortBy(inputTypes, 'label');
            _.each(inputTypes, function(inputType){
                if(isNaN(inputType.label.charAt(0))){
                    $scope.inputTypes.push(inputType);
                }
            });
            _.each(inputTypes, function(inputType){
                if(!isNaN(inputType.label.charAt(0))){
                    $scope.inputTypes.push(inputType);
                }
            });
        }, function(error) {
            console.log("error loading input types");
        })
    };

    var getGoalAssociationTypes = function() {
        FormService.getGoalAssociationTypes().then(function(data) {
            $scope.goalAssociationsTypes = _.orderBy(JSON.parse(data.goalFields), 'displayName');
        }, function(error) {
            console.log("error loading data types");
        })
    }

    function getRollupFieldNames() {
        // For products (line items), the rollup targets are at the order level
        FormService.getOrderRollupTargets().then(function(fieldNames) {
            $scope.rollupTargetFieldNames = fieldNames.sort();
        }, function(error) {
            console.log("Error loading order rollup targets: " + error);
        });
    }

    function getWorkflowActions() {
        WorkflowsService.getWorkflowActions(true).then(function(data) {
            $scope.workflowActions = data;
        }, function() {
            console.log("Error fetching workflow actions.");
        });
    }

    const fieldsHelper = function() {
        $scope.calculateFields = [];
        $scope.hasCalculateFields = false;
        $scope.hasFormulaErrors = false;
        $scope.formulaData = [];
        for (let i = 0, len = $scope.productFields.length; i < len; i++) {
            $scope.productFields[i].display_order = parseInt($scope.productFields[i].display_order);
            for (let j = 0, size = $scope.productFields.length; j < size; j++) {
                if($scope.inputTypesList && $scope.inputTypesList[$scope.productFields[i].input_type]) {
                    $scope.productFields[i].input_type_name = $scope.inputTypesList[$scope.productFields[i].input_type];
                } else {
                    $scope.productFields[i].input_type_name = $scope.productFields[i].input_type;
                }
                if ($scope.productFields[i].parent_id && $scope.productFields[j].id == $scope.productFields[i].parent_id) {
                    $scope.productFields[i].parent_name = $scope.productFields[j].field_name;
                    break;
                }
            }
            if (($scope.productFields[i].input_type == 'calculated' || $scope.productFields[i].input_type == 'calculated-override') &&
                $scope.productFields[i].formula && $scope.productFields[i].active == '1') {
                $scope.calculateFields.push($scope.productFields[i]);
                $scope.hasCalculateFields = true;
                if ($scope.productFields[i].__FORMULA_ERROR__) {
                    $scope.hasFormulaErrors = true;
                }
                const formulaObj = {
                    id: $scope.productFields[i].id,
                    name: $scope.productFields[i].field_name,
                    formula: $scope.productFields[i].formula,
                    error: $scope.productFields[i].__FORMULA_ERROR__ ? $scope.productFields[i].__FORMULA_ERROR__ : ''
                };
                $scope.formulaData.push(formulaObj);
            }
            if ($scope.productFields[i].custom_edit_action_id && $scope.productFields[i].custom_edit_action_id > 0) {
                const wfAction = _.find($scope.workflowActions, {id: $scope.productFields[i].custom_edit_action_id});
                if (wfAction) {
                    $scope.productFields[i].custom_edit_action_name = wfAction.name;
                } else {
                    $scope.productFields[i].custom_edit_action_name = '(not found)';
                }
            }
            if (!$scope.showSynchronized && $scope.productFields[i].__new_ui_product_field_id) {
                $scope.showSynchronized = true;
            }
        }
        $scope.productFields = _.orderBy($scope.productFields, 'display_order');
    }

    $scope.showFormulaErrors = function() {
        $modal.open(
            ModalService.returnModalType('showFormulaErrors', {
                data: {
                    formulaErrors: $scope.formulaData
                }
            })
        );
    }

    const filterGroupProductFields = function(groupId){
        $scope.productFieldObj[groupId] = [];
        _.each($scope.productFields, function(productField){
            if (groupId == productField.group_id && productField.active=='1') {
                $scope.productFieldObj[groupId].push(productField);
            }
        });
    }

    $scope.toggleInformationBeingDisplayed = function() {
        $scope.isExpandCollapseButtonDisabled = true;
        let isExpandingAllGroups = $scope.willExpandAllGroups;
        $scope.willExpandAllGroups = !$scope.willExpandAllGroups;
        $timeout(function () {
            if (isExpandingAllGroups) {
                $('span[data-toggle-display="expand"]').click();
            } else {
                $('span[data-toggle-display="collapse"]').click();
            }
        }, 0);
        $timeout(function () {
            $scope.isExpandCollapseButtonDisabled = false;
        }, 900);
    }

    //Toggle product fields for a product group
    $scope.toggleGroup = function(ev, group) {
        if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
            $(ev.target).parent().parent().siblings().children().last().show(900);
            $(ev.target).removeClass('fa-chevron-right');
            $(ev.target).addClass('fa-chevron-down');
            $(ev.target).attr('data-toggle-display', 'collapse');
            afterExpandingGroup();
            $scope.productFieldObj[group.id] = [];
            $scope.productFilterObj[group.id] = "1";
            $scope.sortableDragIconShowHide[group.id] = "1";
            fieldsHelper();
            filterGroupProductFields(group.id);
            $scope.fieldsHeader[group.id] = angular.copy($scope.fieldsTableData);
            $scope.tbsortableOptions[group.id] = {
                handle: '.ui-sorting-handle',
                axis: "y",
                containment: ".product-content-" + group.id,
                helper: function (e, tr) {
                    var $originals = tr.children();
                    var $helper = tr.clone();
                    $helper.children().each(function (index) {
                        // Set helper cell sizes to match the original sizes
                        $(this).width($originals.eq(index).width());
                    });
                    return $helper;
                },
                stop: function (e, ui) {
                    var groupId = $(ui.item).attr('group-id');
                    var fields = [];
                    var displayOrderCnt = 1;
                    _.each($scope.productFieldObj[groupId], function (element, index) {
                        element.originalDisplayOrder = element.display_order;
                        element.display_order = displayOrderCnt++;
                        if ((element.originalDisplayOrder !== element.display_order)) {
                            fields.push({
                                id: element.id,
                                displayOrder: element.display_order
                            });
                        }
                    });
                    if(fields.length > 0){
                        ProductService.updateProductDisplayOrder(fields).then(function(fieldsData) {
                            if(fieldsData){
                                _.each(fieldsData, function(fieldObj){
                                    var groupField = _.find($scope.productFieldObj[groupId], {id: fieldObj.id});
                                    if(groupField){
                                        groupField.display_order = parseInt(fieldObj.display_order);
                                    }
                                    var productField = _.find($scope.productFields, {id: fieldObj.id});
                                    if(productField){
                                        productField.display_order = parseInt(fieldObj.display_order);
                                    }
                                });
                                $ioAlert.show('', 'Product fields display order updated successfully', 'success');
                            }
                        }, function(error) {
                            console.log("error updating display order");
                            $scope.productLoader = false;
                        });
                    }
                }
            }
        } else {
            $(ev.target).parent().parent().siblings().children().last().hide(600);
            $(ev.target).removeClass('fa-chevron-down');
            $(ev.target).addClass('fa-chevron-right');
            $(ev.target).attr('data-toggle-display', 'expand');
            afterCollapsingGroup();
        }
        
    };

    function afterExpandingGroup() {
        let count = $('span[data-toggle-display="expand"]').length;
        if (count === 0) {
            $scope.willExpandAllGroups = false;
        }
    }

    function afterCollapsingGroup() {
        let count = $('span[data-toggle-display="collapse"]').length;
        if (count === 0) {
            $scope.willExpandAllGroups = true;
        }
    }

    $scope.selectAll = function(groupId) {
        for (var i = 0, len = $scope.fieldsHeader[groupId].length; i < len; i++) {
            $scope.fieldsHeader[groupId][i].id = true;
        }
    }

    $scope.backtoProducts = function() {
        $state.go('products');
    };

    $scope.filterActiveColumn = function(groupId, showActive) {
        $scope.showActive = ! $scope.showActive;
        if ($scope.showActive) {
            $scope.productFilterObj[groupId] = "1"
            $scope.sortableDragIconShowHide[groupId] = "1";
        } else {
            $scope.productFilterObj[groupId] = "";
            $scope.sortableDragIconShowHide[groupId] = "";
        }
    };

    $scope.editGroup = function(group) {
        if (group) {
            $scope.addGroup(group)
        } else {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        }
    };

    $scope.addGroup = function() {
        var param = {};
        param.groupName = "GROUP";
        param.active = 1;
        param.productId = $scope.productId;
        if ( $scope.productGroups &&  $scope.productGroups.length) {
            param.groupDisplayOrder = Math.max.apply(Math,  $scope.productGroups.map(function(o) {
                return parseInt(o.group_display_order);
            })) + 1;
        } else {
            param.groupDisplayOrder = 1;
        }

        ProductService.saveProductGroups(param).then(function(data) {
            if (data?.id) {
                data.active = data.active == '1';
                $scope.productGroups.push(data);
                $ioAlert.show('', 'Product Group created successfully', 'success');
            }
            updateDisplayGroups();
            $scope.productsLoader = false;
        }, function (error) {
            console.log(error);
            $ioAlert.show('Error!', JSON.stringify(error), 'error');
            $scope.productsLoader = false;
        });
    };

    $scope.deleteGroup = function(groupId) {
        $confirm.open({
            size: 'sm',
            text: 'Are you sure you want to delete this Product Group?'
        }).then(function() {
            ProductService.deleteProductGroup(groupId).then(function() {
                getProductGroups();
                $ioAlert.show('Product Group deleted', 'Product Group has been successfully deleted', 'success');
            }, function(error) {
                console.log("error deleting TapIO Product Group");
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }, function() {})
    };

    $scope.cloneProduct = function() {

        var modalObj = $modal.open(
            ModalService.returnModalType('cloneProductGroup', {
                data: {
                    productId: $scope.productId
                }
            })
        );

        modalObj.result.then(function(formObj) {
            ProductService.cloneProduct($scope.productId, formObj.name).then(function() {
                $ioAlert.show('', 'New product ' + formObj.name + ' created successfully', 'success');
            }, function(error) {
                $ioAlert.show('', error, 'error');
            });

        }, function(cancel) {});
    };

        /*
        * Handle modal close
        */
        $scope.hideFieldForm = function() {
            let myElement = angular.element( document.querySelector( '#fieldForm' ) );
            myElement.addClass('fieldFormInactive');
            $timeout(function () {
                $scope.modalShown = false;
            }, 1000);
        }

       /*
       *    Handle showing sliding box for add and edit product field
       */ 
       $scope.showFieldForm = function(group, field, is_copy = false) {
            $scope.modalShown = true;
            $scope.currentGroup = group;
            $scope.fieldsObj = {
               "groupId": $scope.currentGroup.id,
               "displayOrder":$scope.currentGroup.group_display_order,
               "isEditable": "enable"
            };
            $scope.groupName = $scope.currentGroup.group_name;
            $scope.isNew = true;
            $scope.disableDisplayOrder = false;
            $scope.fieldHeaderName ="Add Field";
            $location.hash('field-body');
            anchorSmoothScroll.scrollTo('field-body');
            $timeout(function () {
               $location.hash('');
            }, 3000);
            if (field) {
                $scope.isNew = is_copy;
                $scope.disableDisplayOrder = true;
                if (!is_copy) {
                    $scope.fieldHeaderName ="Update Field";
                } else {
                    $scope.fieldHeaderName ="Copy Field #" + field.id + " As New Field";
                }
                $scope.groupName = $scope.currentGroup.group_name;
                formatObj(field, is_copy);
                if (field.parent_id) {
                    $scope.checkLookup(field);
                }
            } else {
                $scope.fieldsObj.active = true;
                if(!_.isEmpty(highlightedField)) {
                    $scope.fieldsObj.displayOrder = highlightedField.display_order + 1;
                }
                else if ($scope.productFieldObj[group.id] && $scope.productFieldObj[group.id].length) {
                    $scope.fieldsObj.displayOrder = Math.max.apply(Math, $scope.productFieldObj[group.id].map(function(o) {
                        return parseInt(o.display_order);
                    })) + 5;
                }
                else {
                    $scope.fieldsObj.displayOrder =0;
                }
            }
        };


        // initialize our variable to null
        $scope.addFieldHeighlight = function (groupId, feildindex, field) {  //function that sets the value of selectedRow to current index
            _.each($scope.productGroups, function (element) {
                if (element.id == groupId) {
                    _.each($scope.productFieldObj[element.id], function (fieldObj) {
                        if (fieldObj.id == field.id) {
                            highlightedField = (highlightedField && fieldObj.id == field.id) ? {} : field;
                            $scope.selectedRow = ($scope.selectedRow == feildindex) ? null : feildindex;
                            $scope.grouprow = element.id;
                        }
                    });
                }
            });
        }


        /*
        *    Handle save and edit product field
        */
        $scope.addField = function (formObj, fieldsForm) {
            if (!fieldsForm.$valid) {
                $ioAlert.show('', 'Please fill the required fields', 'error')
                return
            }

            if (!formObj.fieldName.match(/^[a-zA-Z0-9_]+$/)) {
                $ioAlert.show('Error', 'Field Name allows Alpha Numeric Characters and Underscores ( _ ) only', 'error')
                return
            }

            if(formObj.fieldName.length > FIELD_MAX_LENGTH) {
                const message = 'Field Name length should be less than ' + FIELD_MAX_LENGTH + ' characters'
                $ioAlert.show('Error', message, 'error');
                return
            }

            if ((formObj.inputType === 'calculated' || formObj.inputType === 'calculated-override') && !formObj.formula) {
                $ioAlert.show('Error', `A ${formObj.inputType} field must have a formula`)
                return
            }

            let group = $scope.currentGroup; // Cannot be const in case we change the field's group
            let params = angular.copy(formObj)

            params.productId = $scope.productId
            if (params.required == true) {
                params.required = 1
            } else {
                params.required = 0
            }
            if (params.clearOnClone == true) {
                params.clearOnClone = 'yes'
            } else {
                params.clearOnClone = 'no'
            }
            if (params.gridShow == true) {
                params.gridShow = 1
            } else {
                params.gridShow = 0
            }
            if (params.active == true) {
                params.active = "yes"
            } else {
                params.active = "no"
            }
            if (params.showLongText == true) {
                params.showLongText = 1
            } else {
                params.showLongText = 0
            }
            if (params.dashboardEnabled == true) {
                params.dashboardEnabled = "yes"
            } else {
                params.dashboardEnabled = "no"
            }
            if (params.hasDateRules == true) {
                params.hasDateRules = 1
            } else {
                params.hasDateRules = 0
            }
            params.enableTypeAhead = (params.enableTypeAhead === true || params.enableTypeAhead == "1") ? 1 : 0
            if (params.dataType == 'date' && params.defaultValue) {
                const defaultValue = {
                    dateOption: params.defaultValue,
                    numDays: params.numDays,
                    businessDay: params.businessDay,
                };
                params.defaultValue = JSON.stringify(defaultValue);
            } else if (params.inputType == 'multiselect' || params.inputType == 'multiselect-custom') {
                if (params.defaultValue && angular.isArray(params.defaultValue)) {
                    params.defaultValue = JSON.stringify(params.defaultValue)
                } else {
                    params.defaultValue = JSON.stringify([]);
                }
            } else if(params.defaultValue && !angular.isString(params.defaultValue)){
                params.defaultValue = JSON.stringify(params.defaultValue);
            }
            if ($scope.isNew) {
                if (params.hasDateRules) {
                    params.updateDateRule = "yes"
                    _.each($scope.productFields, function (fieldObj) {
                        if (fieldObj.field_name == 'start_date' || fieldObj.field_name == 'end_date') {
                            if (fieldObj.date_rules) {
                                params.dateRules = fieldObj.date_rules
                            }
                        }
                    })
                }
                ProductService.saveProductField(params).then(function (data) {
                    if (data) {
                        if (!$scope.productFieldObj[group.id]) {
                            $scope.productFieldObj[group.id] = []
                        }
                        $scope.productFields.push(data);
                        filterGroupProductFields(data.group_id);
                        fieldsHelper();
                        getProductFields();
                        $scope.showForm = false
                        $scope.modalShown = false
                        $ioAlert.show('', 'Field Added successfully', 'success');
                    }
                }, function (error) {
                    console.log("error saving form")
                    $scope.productLoader = false
                    $ioAlert.show('Error!', error, 'error')
                })
            } else {
                if (params.groupId && (params.groupId != group.id)) {
                    params.displayOrder = FormService.computeHighestDisplayOrderInGroup($scope.productFields, params.groupId);
                }
                ProductService.updateProductField(params).then(function (productField) {
                    if (productField) {
                        processUpdateProductFieldsSuccess(group, productField);
                    }
                }, function (data) {
                    if (data.requires_deletion) {
                        // Get user confirmation, they try to update the field again.
                        const message = data.message;
                        const numAffectedFields = data.num_affected_fields;
                        let modalForceObj = $modal.open(
                            ModalService.returnModalType('forceAddOrUpdateFormField', {
                                data: {
                                    message: message,
                                    numAffectedFields: numAffectedFields,
                                }
                            })
                        );
                        modalForceObj.result.then(function() {
                                // Note that we could support data.conversion_possible one day.
                                params.__FORCE_DELETE_EXISTING_VALUES__ = 1;
                                ProductService.updateProductField(params).then(function (productField) {
                                    if (productField) {
                                        processUpdateProductFieldsSuccess(group, productField);
                                    }
                                }, function (data) {
                                    console.log("Error updating product field: " + data.errors);
                                    $scope.productLoader = false;
                                    $ioAlert.show('Error!', data.errors, 'error')
                                });
                            }, function(cancel) {
                                $scope.showForm = false;
                                $scope.modalShown = false;
                                $scope.productLoader = false;
                                $ioAlert.show('', 'Update operation cancelled', 'warn');                        }
                        );
                    } else {
                        console.log("error updating product field: " + data.errors)
                        $scope.productLoader = false
                        $ioAlert.show('Error!', data.errors, 'error')
                    }
                })
            }
        }

        const processUpdateProductFieldsSuccess = function(group, productField) {
            for (let i = 0, len = $scope.productFields.length; i < len; i++) {
                if (productField.id == $scope.productFields[i].id) {
                    $scope.productFields[i] = productField;
                    break;
                }
            }
            fieldsHelper();
            filterGroupProductFields(productField.group_id);
            if (productField.group_id != group.id) {
                filterGroupProductFields(group.id) // If it was moved to another group, filter the old group too
                // And if it was moved, we need to recompute both groups' can_be_deleted attribute to correctly
                // display the trash can icon that allows deleting the group.
                group.can_be_deleted = FormService.groupCanBeDeleted(group.id, $scope.productFields);
                let newGroup = _.find($scope.productGroups, {id: productField.group_id});
                if (newGroup) {
                    newGroup.can_be_deleted = FormService.groupCanBeDeleted(productField.group_id, $scope.productFields);
                }
            }
            $scope.showForm = false;
            $scope.modalShown = false;
            $scope.productLoader = false;
            $ioAlert.show('', 'Field updated successfully', 'success');
        };

            /*
            *    Get lookup content for selected input type
            */
        $scope.getLookupContent = function(resetDefaultVal=false){
            if ($scope.fieldsObj.inputType == 'checkbox') {
                $scope.defaultLookupContents = [
                    {name:'Yes', value: 1},
                    {name:'No', value: 0},
                ];
                return;
            }
            if($scope.fieldsObj.lookupTypeId){
                if(resetDefaultVal && $scope.fieldsObj.inputType == 'multiselect' && $scope.fieldsObj.inputType == 'multiselect-custom'){
                    $scope.fieldsObj.defaultValue = [];
                }
                $scope.clusterId = ClusterService.clusterIds[0];
                ProductService.getLookupContent($scope.fieldsObj.lookupTypeId, $scope.clusterId).then(function() {
                    $scope.defaultLookupContents = _.orderBy(ProductService.lookupContents, 'lookup_value');
                    $scope.defaultLookupContents.forEach(lookupContent => {
                        if (lookupContent.parent_name && lookupContent.parent_name.length > 0) {
                            lookupContent.lookup_value = lookupContent.lookup_value + 
                            ' <- ' + lookupContent.parent_name;
                        }
                    });
                }, function() {
                    console.log("error loading lookup contents for lookup type Id: ");
                });
            }
        }

        /*
        *    Handle formatting the product fields object
        */ 
        var formatObj = function(obj, is_copy = false) {
            let keys = Object.keys(obj);
            let prev_field_id = $scope.fieldsObj.id;
            for (var i = 0, len = keys.length; i < len; i++) {
                switch (keys[i]) {
                    case 'id':
                        $scope.fieldsObj.id = obj[keys[i]];
                        break;
                    case 'data_type':
                        $scope.fieldsObj.dataType = obj[keys[i]];
                        break;
                    case 'field_name':
                        if (is_copy){
                            $scope.fieldsObj.fieldName = obj[keys[i]] + "_copy";
                        } else {
                            $scope.fieldsObj.fieldName = obj[keys[i]];
                        }
                        break;
                    case 'display_name':
                        if (is_copy) {
                            $scope.fieldsObj.displayName = obj[keys[i]] + " (Copy)";
                        } else {
                            $scope.fieldsObj.displayName = obj[keys[i]];
                        }
                        break;
                    case 'input_type':
                        $scope.fieldsObj.inputType = obj[keys[i]];
                        break;
                    case 'is_editable':
                        $scope.fieldsObj.isEditable = (obj[keys[i]])?obj[keys[i]]:'enable';
                        break;
                    case 'parent_id':
                        $scope.fieldsObj.parentId = obj[keys[i]];
                        break;
                    case 'parent_trigger_id':
                        $scope.fieldsObj.parentTriggerId = obj[keys[i]];
                        break;
                    case 'lookup_type_id':
                        $scope.fieldsObj.lookupTypeId = obj[keys[i]];
                        break;
                    case 'required':
                        $scope.fieldsObj.required = (obj[keys[i]] == 1);
                        break;
                    case 'clear_on_clone':
                        $scope.fieldsObj.clearOnClone = (obj[keys[i]] == 1);
                        break;
                    case 'cascading_field_name':
                        $scope.fieldsObj.cascadingFieldName = obj[keys[i]];
                        break;
                    case 'display_order':
                        if (is_copy) {
                            $scope.fieldsObj.displayOrder = parseInt(obj[keys[i]]) + 1;
                        } else {
                            $scope.fieldsObj.displayOrder = parseInt(obj[keys[i]]);
                        }
                        break;
                    case 'active':
                        $scope.fieldsObj.active = (obj[keys[i]] == 1);
                        break;
                    case 'show_long_text':
                        $scope.fieldsObj.showLongText = obj[keys[i]] == 1 ? true : false;
                        break;
                    case 'enable_type_ahead':
                        $scope.fieldsObj.enableTypeAhead = obj[keys[i]] == 1 ? true : false;
                        break;    
                    case 'grid_show':
                        $scope.fieldsObj.gridShow = (obj[keys[i]] == 1);
                        break;
                    case 'help_text':
                        $scope.fieldsObj.helpText = obj[keys[i]];
                        break;
                    case 'formula':
                        $scope.fieldsObj.formula = obj[keys[i]];
                        break;
                    case 'validation_rules':
                        $scope.fieldsObj.validationRules = obj[keys[i]];
                        break;
                    case 'goal_association':
                        $scope.fieldsObj.goalAssociation = obj[keys[i]];
                        break;
                    case 'rollup_field_name':
                        $scope.fieldsObj.rollupFieldName = obj[keys[i]];
                        break;
                    case 'custom_edit_action_id':
                        $scope.fieldsObj.customEditAction = obj[keys[i]];
                        break;
                    case 'notes':
                        $scope.fieldsObj.notes = obj[keys[i]];
                        break;
                    case 'default_value':
                        let defaultValue = obj[keys[i]];
                        $scope.fieldsObj.defaultValue = defaultValue;
                        if (obj.data_type === "time" && defaultValue) {
                            if(defaultValue.indexOf(":")>0 && (defaultValue.indexOf(" AM")>0 || defaultValue.indexOf(" PM")>0)){
                                let timeData = defaultValue.split(" ");
                                const ampm = timeData[1];
                                timeData = timeData[0].split(":");
                                timeData[0] = (ampm === "PM")?(parseInt(timeData[0]) + 12):parseInt(timeData[0]);
                                timeData[0] = (parseInt(timeData[0]) < 10)?"0"+parseInt(timeData[0]):parseInt(timeData[0]);
                                timeData[1] = (parseInt(timeData[1]) < 10)?"0"+parseInt(timeData[1]):parseInt(timeData[1]);
                                $scope.fieldsObj.timeEditor = timeData[0]+":"+timeData[1]+":00";
                            }
                        } else if (obj.data_type === 'date' && defaultValue) {
                            let params = '';
                            try {
                                params = JSON.parse(defaultValue);
                            } catch (e) {
                                params = 'string'
                            }
                            if ((typeof params) == 'object') {
                                $scope.fieldsObj.defaultValue = params.dateOption;
                                $scope.fieldsObj.numDays = params.numDays;
                                const offset = parseInt(params.numDays);
                                $scope.dateOffset = isNaN(offset) ? 0 : offset;
                                $scope.fieldsObj.businessDay = params.businessDay;
                            }
                        }
                        break;    
                    case 'dashboard_enabled':
                        $scope.fieldsObj.dashboardEnabled = (obj[keys[i]] == 1);
                        break;
                    case 'has_date_rules':
                        $scope.fieldsObj.hasDateRules = obj[keys[i]] == '1' ? true : false;
                        break;
                }
            }
            if(prev_field_id != $scope.fieldsObj.id) {
                $scope.defaultValuePrevType = "";
            }
            $scope.checkType();
        };

        /*
        *    Handle properties of selected input types 
        */ 
        $scope.checkType = function() {
            switch ($scope.fieldsObj.inputType) {
                case 'creative':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "file";
                    break;
                case 'geo-location':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'geo-targeting-google':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'location-picker':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'location-picker-fb':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'location-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'google-ads-aud-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'DFP':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'day-parting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'ad-schedule':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'metric-select':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'ad-group':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'google-ads-bidding':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'facebook-create-ads':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'shopping_adgroup_singleproduct':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'shopping_adgroup_multiproduct':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'dfp-frequency':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'devices':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'device-capability':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'dfp_ad_units':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'connection':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'mobile-app':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'service-mapper':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.fieldName = "serviceMapper";
                    $scope.isFieldNameDisable = true;
                    $scope.fieldsObj.dataType = "string";
                    break;
                case 'multiple-mappings':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'inventory-filter':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'checkbox':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "tinyint";
                    break;
                case 'currency':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "currency";
                    break;
                case 'percentage':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "percentage";
                    break;
                case 'file':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "file";
                    break;
                case 'custom_file':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "file";
                    break;
                case 'emoji':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "string";
                    break;
                case 'select':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "string";
                    break;
                case 'select2':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "string";
                    break;    
                case 'multiselect':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "string";
                    break;
                case 'multiselect-custom':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "string";
                    break;
                case 'timeselect':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "time";
                    break;
                case 'facebook-ads-location':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'xandr-invest-location':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'facebookAds-frequency-controls':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'snapchat-ads-location':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'snapChat-frequency-controls':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'xandrInvest-frequency-controls':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'facebook-audience-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'facebook-audiences':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'snap-gender':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'advanced-demographics':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'snap-predefined-audiences':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'pinterest-audience-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'pinterestAds-frequency-controls':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'tritonAds-frequency-controls':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'custom-macro-mapping':
                case 'custom-macro-mapping-2':
                case 'seed-list-macros':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'google-ads-extension':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'tritonAds-teams-controls':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'yelpAds-categories':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'linkedin-audience-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'tiktok-audience-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'tiktok-device-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'bridge-email-test':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'image-upload':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'links-and-main-cta':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'final-approval':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'google-ad-manager-avail-units':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'pinterest-geo-location':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'facebook-page-id':
                case 'triton-listener-targeting':
                case 'triton-geo-targeting ':
                case 'triton-creative-management':
                case 'linkedin-geo-targeting':
                case 'triton-time-targeting':
                case 'triton-content-targeting':
                case 'snapchat-pixel-controls':
                case 'accountability-group-label':
                case 'tiktok-geo-targeting':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'pinterest-keyword':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'linkedin-campaign-objective':
                    $scope.isDisabled = true;
                    $scope.fieldsObj.dataType = "json";
                    break;
                case 'readonly':
                case 'textarea':
                case 'textplain-area':
                    // to avoid using hyperlink
                    $scope.fieldsObj.dataType = "string";
                    // do not need break here, we will continue using default
                default:
                    $scope.isFieldNameDisable = false;
                    $scope.isDisabled = false;
            }
            if ($scope.fieldsObj.inputType == 'select' ||
                $scope.fieldsObj.inputType == 'multiselect' ||
                $scope.fieldsObj.inputType == 'multiselect-custom' ||
                $scope.fieldsObj.inputType == 'checkbox'
            ) {
                $scope.getLookupContent();
            }
            if ($scope.fieldsObj.inputType == 'select' && !angular.isString($scope.fieldsObj.defaultValue)) {
                $scope.fieldsObj.defaultValue = null;
            }
            if (FormService.inputTypesNoLookupType().includes($scope.fieldsObj.inputType)) {
                $scope.showLookupType = false;
                $scope.fieldsObj.lookupTypeId = null;
            } else {
                $scope.showLookupType = true;
            }
            $scope.checkDataType();
        };

        /*
        *   Handle goal association type
        */
        $scope.changeGoalAssociationType = function() {
            switch($scope.fieldsObj.goalAssociation) {
                case 'name':
                case 'campaign_name':
                case 'column':
                case 'service_id':
                case 'smart_campaign_id':
                    $scope.fieldsObj.dataType = 'string';
                    $scope.isDisabled = true;
                    break;
                case 'target':
                    $scope.fieldsObj.dataType = 'decimal';
                    $scope.isDisabled = true;
                    break;
                case 'start':
                case 'end':
                    $scope.fieldsObj.dataType = 'date';
                    $scope.isDisabled = true;
                    break;
                case 'customer_id':
                    $scope.fieldsObj.dataType = 'integer';
                    $scope.isDisabled = true;
                    break;
                case 'threshold_1':
                case 'threshold_2':
                    $scope.fieldsObj.dataType = 'tinyint';
                    $scope.isDisabled = true;
                    break;
            }
        }

        /*
        *    Handle checking the datatype and assigning related properties
        */ 
        $scope.checkDataType = function() {
            switch ($scope.fieldsObj.dataType) {
                case 'currency':
                case 'percentage':
                case 'decimal':
                case 'integer':
                case 'tinyint':
                    $scope.fieldsObj.defaultValue = parseFloat($scope.fieldsObj.defaultValue);
                    $scope.defaultValueDisabled = false;
                    $scope.defaultValueType = 'number';
                    $scope.defaultInputType = 'text';
                    break;
                case 'date':
                    $scope.defaultValueDisabled = false;
                    $scope.defaultValueType = 'date';
                    $scope.defaultInputType = 'date';
                    break;
                case 'time':
                    if($scope.fieldsObj.defaultValue && typeof $scope.fieldsObj.defaultValue == "string"){
                        var dateVal = String($scope.fieldsObj.defaultValue);
                        if(dateVal.indexOf("T")>=0){
                            var dateObj = new Date(dateVal);
                        }else{
                            dateVal = dateVal.split(":");
                            var dateObj = new Date(0, 0, 0, parseInt(dateVal[0]), parseInt(dateVal[1]), 0);
                        }
                        $scope.fieldsObj.timeEditor = dateObj;
                    }
                    $scope.defaultValueDisabled = false;
                    $scope.defaultValueType = 'time';
                    $scope.defaultInputType = 'time';
                    break;
                case 'hyperlink':
                    $scope.fieldsObj.dataType = [
                        'text',
                        'calculated',
                        'calculated-override'
                    ].includes($scope.fieldsObj.inputType) ?
                        'hyperlink' : 'string';
                    // Do not need break here, we will continue using 'string'
                case 'string':
                    $scope.defaultValueDisabled = false;
                    $scope.defaultValueType = 'text';
                    $scope.defaultInputType = 'text';
                    break;
                default:
                    $scope.defaultValueDisabled = true;
                    $scope.defaultValueType = 'text';
                    $scope.defaultInputType = 'text';
            }
            if (!['currency','decimal','integer','percentage'].includes($scope.fieldsObj.dataType)) {
                // Clear the rollup field name if the data type is incompatible with rolling up.
                $scope.fieldsObj.rollupFieldName = undefined;
            }
            if($scope.defaultValuePrevType != "" && ($scope.defaultValuePrevType != $scope.defaultValueType || $scope.defaultValueDisabled === true)){
                $scope.fieldsObj.defaultValue = '';
            }
            if($scope.fieldsObj.inputType == 'select' || $scope.fieldsObj.inputType == 'multiselect' || $scope.fieldsObj.inputType == 'multiselect-custom'){
                $scope.defaultInputType = $scope.fieldsObj.inputType;
                if(($scope.fieldsObj.inputType == 'multiselect' || $scope.fieldsObj.inputType == 'multiselect-custom') && $scope.fieldsObj.defaultValue && !angular.isArray($scope.fieldsObj.defaultValue)){
                    $scope.fieldsObj.defaultValue = JSON.parse($scope.fieldsObj.defaultValue);
                }
            }else if($scope.fieldsObj.inputType == 'checkbox'){
                $scope.defaultInputType = $scope.fieldsObj.inputType;
            }
            $scope.defaultValuePrevType = $scope.defaultValueType;
        }


      
        /*
        *    Handle checking lookup contents
        */ 
        $scope.checkLookup = function(field) {
            $scope.lookupContents = [];
            for (var i = 0, len = $scope.productFields.length; i < len; i++) {
                if ($scope.fieldsObj.parentId == $scope.productFields[i].id) {
                    $scope.showParentMultiSelect = ($scope.productFields[i].input_type == "checkbox") ? false : true;
                    if ($scope.productFields[i].lookup_type_id) {
                        ProductService.getLookupContent($scope.productFields[i].lookup_type_id).then(function() {
                            $scope.lookupContents = _.orderBy(ProductService.lookupContents, 'lookup_value');
                            $scope.lookupContents.forEach(lookupContent => {
                                if (lookupContent.parent_name && lookupContent.parent_name.length > 0) {
                                    lookupContent.lookup_value = lookupContent.lookup_value + 
                                    ' <- ' + lookupContent.parent_name;
                                }
                            });
                        }, function() {
                            console.log("error loading lookup contents for lookup type Id: " + $scope.lookupId);
                        });
                    } else if ($scope.productFields[i].input_type == "checkbox") {
                        $scope.lookupContents = [{
                            "id": "0",
                            "lookup_value": "No"
                        }, {
                            "id": "1",
                            "lookup_value": "Yes"
                        }];
                    }
                }
            }
        };


        function showGroupModal(type, data) {
            data.orderTypes = $scope.orderTypes;
            return $modal.open(ModalService.returnModalType(type, {
                data: data
            }));
        }
        
        /*
        *    Handle cancel the sliding box
        */ 
        $scope.cancelModal = function(){
            $scope.showForm = false;
            $scope.modalShown = false;
        }

        $scope.plusDateOption = function() {
            if ($scope.fieldsObj.defaultValue == undefined ||
                $scope.fieldsObj.defaultValue == '') {
                $scope.fieldsObj.defaultValue = 'Today';
            }
            $scope.dateOffset++;
            const operator = $scope.dateOffset > 0 ? '+':'';
            const offset = $scope.dateOffset == 0 ? '' : $scope.dateOffset;
            $scope.fieldsObj.numDays = operator + offset;
        }

        $scope.minusDateOption = function() {
            if ($scope.fieldsObj.defaultValue == undefined ||
                $scope.fieldsObj.defaultValue == '') {
                $scope.fieldsObj.defaultValue = 'Today';
            }
            $scope.dateOffset--;
            const operator = $scope.dateOffset > 0 ? '+':'';
            const offset = $scope.dateOffset == 0 ? '' : $scope.dateOffset;
            $scope.fieldsObj.numDays = operator + offset;
        }

        $scope.inputNumDays = function() {
            const offset = parseInt($scope.fieldsObj.numDays);
            $scope.dateOffset = isNaN(offset) ? 0 : offset;
        }

        $scope.clearDateOption = function() {
            $scope.fieldsObj.defaultValue = undefined;
            $scope.fieldsObj.numDays = undefined;
            $scope.dateOffset = 0;
        }

        $scope.$watch('fieldsObj.timeEditor', function() {
            if ($scope.fieldsObj?.timeEditor) {
                $scope.fieldsObj.defaultValue =
                    String($filter('date')($scope.fieldsObj.timeEditor, "HH:mm")) + ":00";
            }
        });

        /*
        * Handle get instance lock configuration
        */
        const getInstanceLockConfig = function() {
            FormService.getInstanceLockConfig().then(function(data) {
                if (data.instanceLocked) {
                    $scope.disableBtnAction = true;
                } else {
                    $scope.disableBtnAction = false;
                }

            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }

        const init = function() {
            if ($scope.productId) {
                $scope.productLoader = true;
                ClusterService.initCluster($rootScope.userRole);
                getProductGroups();
                getLookupTypes();
                getDataTypes();
                getInputTypes();
                getGoalAssociationTypes();
                getRollupFieldNames();
                getWorkflowActions();
                getHideConditionTypes();
                getInstanceLockConfig();
                UserService.adjustStickyHeader();
                $scope.isExpandCollapseButtonDisabled = $('span[data-toggle-display="expand"]').length === 0;
            } else {
                $state.go('products');
            }
        };

    init();
    UserService.adjustStickyHeaderWindowResize();
}

ProductLookupController.$inject = ['$scope', '$rootScope', '$stateParams', 'ProductService', 'UserService', 'ClusterService', 'DateRangeService', '$modal', '$state', '$ioAlert', 'ModalService', 'FormService'];

function ProductLookupController($scope, $rs, $stateParams, ProductService, UserService, ClusterService, DateRangeService, $modal, $state, $ioAlert, ModalService, FormService) {
    $scope.productId = $stateParams.id;
    $scope.product = null;
    $scope.lookupTypes = [];
    $scope.lookupContentObj = {};
    $scope.productContentsList = {};
    $scope.disableBtnAction = false;
    $scope.firstTime = true;

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        if ($scope.firstTime) {
            getProduct();
            $scope.firstTime = false;
        } else {
            // If the Business Unit is changed, the product may not be associated with the new one anymore, so just go
            // back to the main products page for that new Business Unit.  We could add logic to figure it out, but
            // we'd need to fetch additional data from the backend and it's probably not worth it.
            $scope.backToProducts();
        }
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    var getProduct = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching lookUp Types";
        ProductService.getProduct($scope.productId).then(function(success) {
            $scope.product = ProductService.product;
            getLookupTypes();
            getAllProducts()
        }, function(error) {
            console.log("error loading product");
        });
    }

    var getAllProducts = function(clusterId) {
        $scope.products = [];
        ProductService.getAllProducts(false).then(function(success) {
            ProductService.products.forEach(function(product) {
                if(product.active == "1") {
                    $scope.products.push(product);
                }
            });                  
        }, function(error) {
            console.log("Error getting products for cluster: " + clusterId);
        });
    };

    var getLookupTypes = function() {
        ProductService.getLookupTypesForProduct($scope.productId).then(function(success) {
            $scope.lookupTypes = ProductService.lookupTypesForProduct;
            $rs.loadingInProgress = false;
        }, function(error) {
            console.log("error loading lookup types");
            $rs.loadingInProgress = false;
        });
    };

    $scope.toggle = function(ev, lookup) {
        var clusterId = null;

        if (ClusterService.clusterIds.length && ClusterService.clusterIds[0] > 0) {
            clusterId = ClusterService.clusterIds[0];
        }

        if (clusterId) {
            $(ev.target).siblings(':last').slideToggle(200);
            if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
                $(ev.target).removeClass('fa-chevron-right');
                $(ev.target).addClass('fa-chevron-down');

                $scope.lookupContentObj[lookup.id] = [];
                $scope.productContentsList[lookup.id] = [];

                ProductService.getLookupContent(lookup.id, clusterId).then(function(success) {
                    $scope.lookupContentObj[lookup.id] = ProductService.lookupContents;
                }, function(error) {
                    console.log("error loading lookup contents");
                });

                ProductService.getProductContents($scope.productId, clusterId, lookup.id).then(function(response) {
                    if (response.productLookupTypeContents) {
                        $scope.productContentsList[lookup.id] = response.productLookupTypeContents;
                    }
                }, function(error) {});
            } else {
                $(ev.target).removeClass('fa-chevron-down');
                $(ev.target).addClass('fa-chevron-right');
            }
        } else {
            $ioAlert.show('Error!', 'You must select a Business Unit.', 'error');
        }
    };

    $scope.addProductContent = function(lookupId, productContent) {
        var isNew = true;

        if (productContent) {
            isNew = false;
        }

        var modalObj = $modal.open(
            ModalService.returnModalType('addProductContent', {
                data: {
                    productId: $scope.productId,
                    lookupAttributes: $scope.lookupContentObj[lookupId],
                    productContent: productContent
                }
            })
        );

        if ((!ClusterService.clusterIds.length || ClusterService.clusterIds[0] == 0)) {
            $ioAlert.show('Error!', 'You must select a business unit.', 'error');
        } else {
            var clusterId = null;

            clusterId = ClusterService.clusterIds[0];

            modalObj.result.then(function(formObj) {
                var param = {};
                param.productId = formObj.productId;
                param.clusterId = clusterId;

                if (!isNew && !formObj.lookupContents) {
                    param.lookupTypeId = lookupId;

                    ProductService.deleteProductContents(param).then(function(data) {
                        $scope.productContentsList[lookupId] = [];
                        $ioAlert.show('', 'Product lookup content deleted successfully', 'success');
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                } else {
                    param.lookupContents = [];

                    if (formObj.lookupContents) {
                        for (var i = 0; i < formObj.lookupContents.length; i++) {
                            param.lookupContents.push(formObj.lookupContents[i].id);
                        }
                    }

                    if (isNew && param.lookupContents.length) {
                        ProductService.addProductContents(param).then(function(data) {
                            if (data) {
                                $scope.productContentsList[lookupId] = data;
                                $ioAlert.show('', 'Product lookup content added successfully', 'success');
                            }
                        }, function(error) {
                            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                        });
                    } else if (!isNew) {
                        ProductService.updateProductContents(param).then(function(data) {
                            if (data) {
                                $scope.productContentsList[lookupId] = data;
                                $ioAlert.show('', 'Product lookup content updated successfully', 'success');
                            }
                        }, function(error) {
                            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                        });
                    }
                }
            }, function(cancel) {});
        }
    };



    $scope.cloneLookupContent = function() {
        if (!ClusterService.clusterIds.length || ClusterService.clusterIds[0] == 0) {
            $ioAlert.show('', 'You must select a business unit to continue.', 'error');
        } else {
            var modalObj = $modal.open(
                ModalService.returnModalType('lookupContentClone', {
                    data: {
                        clusters: ClusterService.clusters.slice(1),  // Shallow copy, skipping item 0 (All Business Units)
                        products: $scope.products,
                        productId: $scope.productId,
                        // products: [],
                        lookupTypes: $scope.lookupTypes
                    }
                })
            );
            modalObj.result.then(function(formObj) {
                $rs.loadingInProgress = true;
                ProductService.cloneProductLookupContent(ClusterService.clusterIds[0], formObj.destClusterIds,
                    $scope.productId, formObj.destProductIds, formObj.lookupTypeIds).then(function(data) {
                    $rs.loadingInProgress = false;
                    if (data.errors) {
                        $ioAlert.show('', data.errors[0], 'error');
                    } else if (data.dest_cluster_ids && data.dest_cluster_ids.length) {
                        $ioAlert.show('', 'Lookup content cloned successfully', 'success');
                    } else {
                        $ioAlert.show('', 'An error occurred cloning lookup content.', 'error');
                    }
                }, function(error) {
                    $rs.loadingInProgress = false;
                    $ioAlert.show('', 'An error occurred cloning lookup content.', 'error');
                });
            }, function(cancel) {});
        }
    };

    $scope.backToProducts = function() {
        $state.go('products')
    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    var init = function() {
        ClusterService.initCluster($rs.userRole);
        DateRangeService.init();
        getProduct();
        getInstanceLockConfig();
        UserService.adjustStickyHeader();
        //getProduct(); (initCluster will post a ClusterChanged event, which triggers a getProduct()
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }
    UserService.adjustStickyHeaderWindowResize();
}

DateRulesController.$inject = ['$scope', '$modalInstance', 'productFields', 'level', '$ioAlert'];

function DateRulesController($scope, $modalInstance, productFields, level, $ioAlert) {
    var clear = function() {
        $scope.dateRulesObj = { startDate: {}, endDate: {} };

        $scope.startDaysFromLabelClass = "pull-left control-label";
        $scope.startDaysFromRequired = false;

        $scope.endDaysFromLabelClass = "pull-left control-label";
        $scope.endDaysFromRequired = false;

        $scope.businessDayClass = "pull-left control-label";

        $scope.disableStartDateBefore = false;
        $scope.disableStartDateAfter = false;
        $scope.disableEndDateBefore = false;
        $scope.disableEndDateAfter = false;
    };
    clear();
    $scope.startDateDependencies = [
        { id: "currentDate", name: "Current Date" },
        { id: "orderStartDate", name: "Order Start Date" },
        { id: "orderEndDate", name: "Order End Date" }
    ];
    $scope.endDateDependencies = [
        { id: "currentDate", name: "Current Date" },
        { id: "orderStartDate", name: "Order Start Date" },
        { id: "orderEndDate", name: "Order End Date" },
        { id: "lineItemStartDate", name: "Line Item Start Date" }
    ];

    if (level == 'flight') {
        $scope.startDateDependencies.push({ id: "lineItemStartDate", name: "Line Item Start Date"});
        $scope.startDateDependencies.push({ id: "lineItemEndDate", name: "Line Item End Date"});
        $scope.endDateDependencies.push({ id: "lineItemEndDate", name: "Line Item End Date"});
        $scope.endDateDependencies.push({ id: "flightStartDate", name: "Flight Start Date"});
    }

    $scope.startDateChange = function() {
        if($scope.dateRulesObj.startDate.numDays) {
            $scope.startDaysFromLabelClass = "pull-left control-label required-days-from";
            $scope.startDaysFromRequired = true;
        }else {
            $scope.startDaysFromLabelClass = "pull-left control-label";
            $scope.startDaysFromRequired = false;
        }
    };

    $scope.endDateChange = function() {
        if($scope.dateRulesObj.endDate.numDays) {
            $scope.endDaysFromLabelClass = "pull-left control-label required-days-from";
            $scope.endDaysFromRequired = true;
        }else {
            $scope.endDaysFromLabelClass = "pull-left control-label";
            $scope.endDaysFromRequired = false;
        }
    };

    $scope.startDateDependencyChange = function() {
        if ($scope.dateRulesObj.startDate.dependency == "orderStartDate" || $scope.dateRulesObj.startDate.dependency == "lineItemStartDate") {
            $scope.disableStartDateBefore = true;
            $scope.disableStartDateAfter = false;
            $scope.dateRulesObj.startDate.validateOn = 'after';
        } else if ($scope.dateRulesObj.startDate.dependency == "orderEndDate" || $scope.dateRulesObj.startDate.dependency == "lineItemEndDate") {
            $scope.disableStartDateBefore = false;
            $scope.disableStartDateAfter = true;
            $scope.dateRulesObj.startDate.validateOn = 'before';
        } else {
            $scope.disableStartDateBefore = false;
            $scope.disableStartDateAfter = false;
            $scope.dateRulesObj.startDate.validateOn = '';
        }
    }

    $scope.endDateDependencyChange = function() {
        if ($scope.dateRulesObj.endDate.dependency == "orderStartDate" || $scope.dateRulesObj.endDate.dependency == "lineItemStartDate" || $scope.dateRulesObj.endDate.dependency == "flightStartDate") {
            $scope.disableEndDateBefore = true;
            $scope.disableEndDateAfter = false;
            $scope.dateRulesObj.endDate.validateOn = 'after';
        } else if ($scope.dateRulesObj.endDate.dependency == "orderEndDate" || $scope.dateRulesObj.endDate.dependency == "lineItemEndDate") {
            $scope.disableEndDateBefore = false;
            $scope.disableEndDateAfter = true;
            $scope.dateRulesObj.endDate.validateOn = 'before';
        } else {
            $scope.disableEndDateBefore = false;
            $scope.disableEndDateAfter = false;
            $scope.dateRulesObj.endDate.validateOn = '';
        }
    }

    $scope.addDateRule = (dateRuleForm) => {
        if (dateRuleForm.$valid) {
            $modalInstance.close($scope.dateRulesObj);
        } else {
            $ioAlert.show('Error!', 'Please fill the all required fields', 'error');
        }
    };

    $scope.cancel = () => {
        $modalInstance.dismiss();
    };

    $scope.clearDateRule = () => {
        clear();
    };

    var init = function() {
        _.each(productFields, function(fieldObj) {
            if (fieldObj.field_name == 'start_date') {
                if (fieldObj.date_rules) {
                    $scope.dateRulesObj.startDate = JSON.parse(fieldObj.date_rules);
                    if ($scope.dateRulesObj.startDate.dependency == "orderStartDate" || $scope.dateRulesObj.startDate.dependency == "lineItemStartDate") {
                        $scope.disableStartDateBefore = true;
                    } else if ($scope.dateRulesObj.startDate.dependency == "orderEndDate" || $scope.dateRulesObj.startDate.dependency == "lineItemEndDate") {
                        $scope.disableStartDateAfter = true;
                    }
                }
            } else if (fieldObj.field_name == 'end_date') {
                if (fieldObj.date_rules) {
                    $scope.dateRulesObj.endDate = JSON.parse(fieldObj.date_rules);
                    if ($scope.dateRulesObj.endDate.dependency == "orderStartDate" || $scope.dateRulesObj.endDate.dependency == "lineItemStartDate" || $scope.dateRulesObj.endDate.dependency == "flightStartDate") {
                        $scope.disableEndDateBefore = true;
                    } else if ($scope.dateRulesObj.endDate.dependency == "orderEndDate" || $scope.dateRulesObj.endDate.dependency == "lineItemEndDate") {
                        $scope.disableEndDateAfter = true;
                    }
                }
            }
        });
    };

    init();
}

function RecalculateAllController($scope, $modalInstance, calculateFields, targetEntity, idList, $ioAlert) {
    $scope.recalculateAllObj = {fieldId: null};
    $scope.calculateFields = calculateFields;
    $scope.targetEntity = targetEntity;
    $scope.idList = idList;

    $scope.triggerRecalculateAll = (recalculateAllForm) => {
        if (recalculateAllForm.$valid) {
            $modalInstance.close($scope.recalculateAllObj);
        } else {
            $ioAlert.show('Error!', 'Please fill the all required fields', 'error');
        }
    };

    $scope.cancel = () => {
        $modalInstance.dismiss();
    };
}

function ShowRecalculateResultsController($scope, $modalInstance, targetEntity, results) {
    $scope.results = results;
    $scope.targetEntity = targetEntity;

    $scope.close = () => {
        $modalInstance.close();
    };
}

ProductFlightsController.$inject = ['$scope', '$rootScope', '$stateParams', '$state', '$ioAlert', '$confirm', 'UserService', 'ProductService', '$modal', 'FormService', 'ModalService', '$filter', 'anchorSmoothScroll', '$location', '$timeout', 'ClusterService', 'WorkflowsService'];

function ProductFlightsController($scope, $rootScope, $stateParams, $state, $ioAlert, $confirm, UserService, ProductService, $modal, FormService, ModalService, $filter, anchorSmoothScroll, $location, $timeout, ClusterService, WorkflowsService) {
    const FIELD_MAX_LENGTH = 44;

    $scope.productId = $stateParams.id;
    $scope.productName = $stateParams.productName;
    $scope.productFieldsLoaded = false;
    $scope.flightFieldObj = [];
    $scope.flightFormId = $stateParams.flightFormId;
    $scope.flightGroups = [];
    $scope.groupNames = [];  // For use by add/edit field modal
    $scope.displayGroups = [];
    $scope.productFilterObj = [];
    $scope.showActiveGroup = true;
    $scope.sortableIconShowHide = true;
    $scope.sortableDragIconShowHide = [];
    $scope.showSynchronized = false;
    $scope.fieldsList = [];      // Used in addField.html too, so cannot rename
    $scope.activeFieldsList = [];      // have to rename, because it includes inactive fields
    $scope.showForm = false;
    $scope.contentTypeId = 4; // Flight
    $scope.rollupTargetFieldNames = [];
    $scope.workflowActions = [];
    $scope.defaultValueDisabled = true;
    $scope.defaultValueType = 'text';
    $scope.defaultInputType = 'text';
    $scope.defaultValuePrevType = '';
    $scope.defaultLookupContents = [];
    $scope.hideEditFlightGroupName = [];
    $scope.oldvalue = {};
    $scope.disableDisplayOrder = false;
    $scope.selectedRow = null;
    $scope.fieldHeaderName ="Add Field";
    let highlightedField = {};
    $scope.clusterId = null;
    $scope.modalShown = false;
    $scope.toggleModal = function() {
        $scope.modalShown = !$scope.modalShown;
    };
    $scope.showActive = true;
    $scope.disableBtnAction = false;
    $scope.showLookupType = true;
    $scope.fieldsTableData = [{
            "name": "Id",
            "value": "id",
            "id": true
        }, {
            "name": "Field Name",
            "value": "field_name",
            "id": true
        }, {
            "name": "Display Name",
            "value": "display_name",
            "id": true
        }, {
            "name": "Data Type",
            "value": "data_type",
            "id": true
        }, {
            "name": "Input Type",
            "value": "input_type_name",
            "id": true
        }, {
            "name": "Cascading Field Name",
            "value": "cascading_field_name",
            "id": true
        }, {
            "name": "Parent",
            "value": "parent_name",
            "id": true
        }, {
            "name": "Parent Trigger",
            "value": "parent_trigger_name",
            "id": true
        }, {
            "name": "Lookup Type Id",
            "value": "lookup_type_id",
            "id": true
        }, {
            "name": "Default Value",
            "value": "default_value",
            "id": true
        }, {
            "name": "Required",
            "value": "required",
            "id": true
        }, {
            "name": 'Show Long Text',
            "value": 'show_long_text',
            "id": true
        }, {
            "name": 'Type ahead',
            "value": 'enable_type_ahead',
            "id": true
        }, {
            "name": "Show in Dashboards",
            "value": "dashboard_enabled",
            "id": true
        }, {
            "name": "Grid Show",
            "value": "grid_show",
            "id": false,
        }, {
            "name": "Active",
            "value": "active",
            "id": false,
        }, {
            "name": "Help Text",
            "value": "help_text",
            "id": true
        }, {
            "name": "Formula",
            "value": "formula",
            "id": true
        }, {
            "name": "Validation Rules",
            "value": "validation_rules",
            "id": true
        }, {
            "name": "Goal Association",
            "value": "goal_association",
            "id": true
        }, {
            "name": "Rollup Field Name",
            "value": "rollup_field_name",
            "id": true
        }, {
            "name": "Distributed Source Field",
            "value": "distributed_source_product_field_name",
            "id": false
        }, {
            "name": "Distribution Type",
            "value": "distribution_type",
            "id": false
        }, {
            "name": "Custom Edit Action",
            "value": "custom_edit_action_name",
            "id": false
    }];

    $scope.fieldsHeader = {};
    $scope.tbsortableOptions = {};
    $scope.fieldTemplate = newFieldHtmlUrl;
    $scope.showParentMultiSelect = true;
    $scope.inputTypesList = [];
    $scope.editableEnum = [
        {"label": "Editable", "value": 'enable'},
        {"label": "Add Only", "value": 'add'},
        {"label": "Edit Only", "value": 'edit'},
        {"label": "Not Editable", "value": 'disable'}
    ];
    $scope.defaultDateOptions = [
        "Today",
        "Tomorrow",
        "Yesterday",
        "Next week",
        "Next month",
    ];
    $scope.distributedSourceFields = [];  // Added dynamically in loadProductFields().
    $scope.distributionTypes = [
        {"label": "Distributed Evenly by Flights", "value": 'distributed_by_flights'},
        {"label": "Distributed by Days", "value": 'distributed_by_days'}
    ];
    $scope.willExpandAllGroups = true;
    $scope.isExpandCollapseButtonDisabled = true;

    const clusterSelector = $rootScope.$on('ClusterChanged', function() {
        $scope.clusterId = ClusterService.clusterIds[0];
    });

    $scope.resetParentId = function() {
        $scope.fieldsObj.parentId = undefined;
        $scope.showParentMultiSelect = true;
    }

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    $scope.enableEditFlightGroupName = function(groupId) {
        $scope.hideEditFlightGroupName[groupId] = true;
    }
    $scope.cancelEditFlightGroupName = function(groupId) {
        $scope.hideEditFlightGroupName[groupId] = false;
    }

    $scope.disableEditFlightGroupName = function(groupId, groupObj) {
        if (groupObj.group_name.length === 0) {
            $ioAlert.show('Error', 'Group name cannot be empty.', 'error');
            $scope.hideEditFlightGroupName[groupId] = true;
        } else if (groupObj.group_name.includes('Buy')) {
            $ioAlert.show('Error', 'Group name cannot include \'Buy\'', 'error');
            $scope.hideEditFlightGroupName[groupId] = true;
        } else {
            if ($scope.oldvalue[groupObj.id] !== groupObj.group_name) {
                $scope.hideEditFlightGroupName[groupId] = false;
                let param = {};
                param.groupName = groupObj.group_name;
                param.groupDisplayOrder = groupObj.group_display_order;
                param.active = groupObj.active;
                param.id = groupObj.id;
                param.formId = $scope.flightFormId;
                $scope.oldvalue[groupObj.id] = groupObj.group_name;
                FormService.updateFormFieldGroups(param).then(function(data) {
                    $ioAlert.show('Success', 'Flight form field group updated successfully', 'success');
                }, function(error) {
                    $ioAlert.show('Error', 'Error updating flight field group', 'error');
                });
            }
        }
    }

    // Handle flight field group active and inactive
    $scope.flightGroupActiveChange = function(groupObj, $event) {
        $event.preventDefault();
        $event.stopPropagation();
        if (groupObj) {
            const text = groupObj.active ? 'Are you sure you want to disable this flight group?' :
                'Are you sure you want to enable this flight group?';
            $confirm.open({
                size: 'sm',
                text: text
            }).then(function() {
                groupObj.active = (groupObj.active == true) ? false : true;
                updateFlightsGroup(groupObj);
            }, function() {});
        }
    }

    const updateDisplayGroups = function() {
        $scope.displayGroups = [];
        _.each($scope.flightGroups, function (groupObj) {
            (groupObj.active == true) ? $scope.displayGroups.push(groupObj) : '';
        });
        $scope.displayGroups = $scope.showActiveGroup == true ? $scope.displayGroups : $scope.flightGroups;
        $scope.groupNames = $scope.flightGroups;
    }

    // Updating Flights Group
    const updateFlightsGroup = function (groupObj) {
        let param = {};
        param.id = groupObj.id;
        param.formId = $scope.flightFormId;
        param.groupName = groupObj.group_name;
        param.groupDisplayOrder = groupObj.group_display_order;
        param.hideForCondition = groupObj.hide_for_condition;
        param.active = (groupObj.active === true || groupObj.active == '1') ? '1' : '0';
        FormService.updateFormFieldGroups(param).then(function (data) {
            if (data.errors) {
                groupObj.active = (groupObj.active == true) ? false : true;
                $ioAlert.show('', data.errors[0], 'error');
            } else {
                if (data.formFieldGroup && data.formFieldGroup.id) {
                    data.formFieldGroup.active = (data.formFieldGroup.active == '1');
                    for (let i = 0, len = $scope.flightGroups.length; i < len; i++) {
                        if ($scope.flightGroups[i].id == data.formFieldGroup.id) {
                            $scope.flightGroups[i] = data.formFieldGroup;
                            break;
                        }
                    }
                    updateDisplayGroups();
                    $ioAlert.show('', 'Updated Successfully', 'success');
                }
            }
        }, function (error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    $scope.iosortableOptions = {
        handle: '.handle',
        stop: function(e, ui) {
            for (let group in $scope.displayGroups) {
                $scope.displayGroups[group].group_display_order = Number(group) + 1;
            }

            _.each($scope.displayGroups, function(groupObj, index) {
                if (groupObj.active == true) {
                    let param = {};
                    param.formId = $scope.flightFormId;
                    param.groupName = groupObj.group_name;
                    param.groupDisplayOrder = groupObj.group_display_order;
                    param.active = groupObj.active;
                    param.id = groupObj.id;
                    param.hideForCondition = groupObj.hide_for_condition;
                    FormService.updateFormFieldGroups(param).then(function(data) {
                        if (index + 1 == $scope.displayGroups.length) {
                            $ioAlert.show('Success', 'Display Order updated successfully', 'success');
                        }

                    }, function(error) {
                        $ioAlert.show('Error', 'Error updating Display Order', 'error');
                    });
                }
            });
        }
    }

    const getRoleTypes = function() {
        UserService.getRoleTypes().then(function(types) {
            $scope.roleTypes = types;
        }, function(error) {
            console.log("Error loading role types");
        });
    };

    const getHideConditionTypes = function () {
        $scope.hideConditionTypes = [];
        $scope.hideConditionTypes.push('Role Type');
        getRoleTypes();
    };

    $scope.filterProductGroupsActiveColumn = function() {
        $scope.showActiveGroup = !$scope.showActiveGroup;
        $scope.sortableIconShowHide = $scope.showActiveGroup;
        updateDisplayGroups();
    }


    $scope.updateFlightsHideCondition = function (group) {
        showGroupModal('updateProductsHideConditionForm', {
            group: group,
            allGroups: $scope.flightGroups,
            hideConditionTypes: $scope.hideConditionTypes,
            roleTypes: $scope.roleTypes,
        }).result.then(function(formObj) {
            group.hide_for_condition = {
                "type": formObj.hideForConditionType,
                "id": formObj.hideForCondition.toString()
            };
            group.hide_for_condition = JSON.stringify(group.hide_for_condition);
            updateFlightsGroup(group);
        }, function(error) {})
    };

    /*
     * Handle add date rule
     */
    $scope.showDateRules = function() {
        if (haveStartEndDates()) {
            $modal.open({
                controller: 'DateRulesController',
                templateUrl: dateRulesHtmlUrl,
                resolve: {
                    productFields: function() {
                        return $scope.fieldsList;
                    },
                    level: function() {
                        return 'flight';
                    }
                },
                backdrop: 'static'
            }).result.then(function(dateRulesObj) {
                _.each($scope.fieldsList, function(fieldObj) {
                    if (fieldObj.field_name == 'start_date') {
                        updateFormFieldDateRule(fieldObj, dateRulesObj.startDate);
                    } else if (fieldObj.field_name == 'end_date') {
                        updateFormFieldDateRule(fieldObj, dateRulesObj.endDate);
                    }
                });
            }, function(cancel) {
            });
        } else {
            $ioAlert.show('Error!', 'You must add "start_date" and "end_date" fields before configuring date rules', 'error');
        }
    }

    const haveStartEndDates = function() {
        let hasStartDate = false;
        let hasEndDate = false;
        _.each($scope.fieldsList, function(fieldObj) {
            if (fieldObj.field_name == 'start_date') {
                hasStartDate = true;
            } else if (fieldObj.field_name == 'end_date') {
                hasEndDate = true;
            }
        });
        return (hasStartDate && hasEndDate);
    }

    $scope.recalculateAll = function() {
        // We really would need the product, but a form field does the job too, and that's what the backend already
        // does.  If we get here, we have at least one calculateFields, so use the first one, it's as good as any.
        FormService.flightIdsUsingFormField($scope.calculateFields[0].id).then(function(data) {
            if (data && data.id_list) {
                if (data.id_list.length == 0) {
                    $ioAlert.show('Error', 'There are no flights using this product', 'error');
                } else {
                    recalculateAllExec(data.id_list);
                }
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Could not fetch the list of flight ids using this product', 'error');
        });
    }

    const recalculateAllExec = function(idList) {
        $modal.open({
            controller: 'RecalculateAllController',
            templateUrl: recalculateAllHtmlUrl,
            resolve: {
                calculateFields: function() {
                    return $scope.calculateFields
                },
                targetEntity: function() {
                    return 'flight'
                },
                idList: function() {
                    return idList
                }
            },
            backdrop: 'static'
        }).result.then(function(recalculateAllObj) {
            FormService.recalculateAllFlights(recalculateAllObj.fieldId).then(function(data) {
                if (data) {
                    showRecalculateResults(data);
                } else {
                    $ioAlert.show('Error', 'Error recalculating flight attributes', 'error');
                }
            }, function(error) {
                console.log("Error recalculating attributes");
                $ioAlert.show('Error', 'Error recalculating flight attributes', 'error');
            });
        }, function(cancel) {
        });
    }

    const showRecalculateResults = function(results) {
        $modal.open({
            controller: 'ShowRecalculateResultsController',
            templateUrl: showRecalculateResultsHtmlUrl,
            resolve: {
                results: function() {
                    return results
                },
                targetEntity: function() {
                    return 'flight'
                }
            },
            backdrop: 'static'
        }).result.then(function(ok) {
        }, function(cancel) {
        });
    }

    const updateFormFieldDateRule = function(fieldObj, dateRuleObj) {
        let params = {};
        params.id = fieldObj.id;
        params.active = (fieldObj.active == "1") ? 'yes' : 'no';
        params.cascadingFieldName = fieldObj.cascading_field_name;
        params.contentTypeId = fieldObj.content_type_id;
        params.dashboardEnabled = (fieldObj.dashboard_enabled == "1") ? 'yes' : 'no';
        params.dataType = fieldObj.data_type;
        params.dateRules = dateRuleObj.numDays ? JSON.stringify(dateRuleObj) : '';
        params.defaultValue = fieldObj.default_value;
        params.displayName = fieldObj.display_name;
        params.displayOrder = fieldObj.display_order;
        params.fieldName = fieldObj.field_name;
        params.formula = fieldObj.formula;
        params.gridShow = (fieldObj.grid_show == "1") ? 'yes' : 'no';
        params.groupId = fieldObj.group_id;
        params.hasDateRules = dateRuleObj.numDays ? 1 : 0;
        params.helpText = fieldObj.help_text;
        params.inputType = fieldObj.input_type;
        params.lookupTypeId = fieldObj.lookup_type_id;
        params.parentId = fieldObj.parent_id;
        params.parentTriggerId = fieldObj.parent_trigger_id;
        params.formId = fieldObj.form_id;
        params.required = (fieldObj.required == "1") ? "yes" : "no";
        params.showLongText = (fieldObj.show_long_text == "1") ? 0 : 0;
        params.enableTypeAhead = (fieldObj.enable_type_ahead == "1") ? 1 : 0;
        params.validationRules = fieldObj.validation_rules;
        params.goalAssociation = fieldObj.goal_association;
        params.rollupFieldName = fieldObj.rollup_field_name;
        params.distributedSourceProductFieldId = fieldObj.distributed_source_product_field_id;
        params.distributionType = fieldObj.distribution_type;
        params.customEditAction = fieldObj.custom_edit_action_id;
        params.updateDateRule = 'yes';

        FormService.updateFormFields(params).then(function(data) {
            if (data) {
                const fieldIndex = _.findIndex($scope.fieldsList, { id: data.id });
                if (fieldIndex) {
                    $scope.fieldsList[fieldIndex] = data;
                }
                if (data.field_name == "end_date") {
                    $ioAlert.show('Success', 'Date Rules updated successfully', 'success');
                }
            }
        }, function(data) {
            console.log("Error updating flight form field: " + data.errors);
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    const getFlightFieldGroups = function() {
        $rootScope.loadingInProgress = true;
        $rootScope.loadertitle = "Fetching Flight Data";

        FormService.getFormFieldGroups($scope.flightFormId, null, 1).then(function(data) {
            $scope.flightGroups = data;
            $scope.displayGroups = [];
            _.each($scope.flightGroups, function(groupObj) {
                $scope.oldvalue[groupObj.id] = groupObj.group_name;
                groupObj.active = (groupObj.active == "1");
                (groupObj.active == true) ? $scope.displayGroups.push(groupObj) : '';
            });
            $scope.displayGroups = $scope.showActiveGroup == true ? $scope.displayGroups : $scope.flightGroups;
            $scope.groupNames = $scope.flightGroups;
            $scope.isExpandCollapseButtonDisabled = data.length === 0
            getFlightFields();
        }, function() {
            console.log("Error loading flight fields group data");
        });
    };

    //Get flight fields for a product id
    const getFlightFields = function() {
        FormService.getFormFields($scope.flightFormId, null, true).then(function(data) {
            if (data) {
                $scope.fieldsList = data;
                fieldsHelper();
                $scope.activeFieldsList = $scope.fieldsList.filter(field => field.active == 1);
                $scope.activeFieldsList = _.orderBy($scope.fieldsList, 'display_name');

                var otherDates = $scope.activeFieldsList.filter(field => field.data_type == "date")
                    .map(field => (field.field_name));
                $scope.defaultDateOptions.push.apply($scope.defaultDateOptions, otherDates);
            }
            $rootScope.loadingInProgress = false;
        }, function() {
            $rootScope.loadingInProgress = false;
            console.log("Error loading flight fields data");
        });
    };

    const getLookupTypes = function() {
        ProductService.getLookupTypes().then(function(success) {
            $scope.lookUpTypes = _.orderBy(ProductService.lookupTypes, (item) => item.name.toLowerCase());
        }, function(error) {
            console.log("Error loading lookup types: " + error);
        });
    };

    const getDataTypes = function() {
        FormService.getDataTypes().then(function(data) {
            $scope.dataTypes = data.sort();
            $scope.allDataTypes = data.sort();
        }, function(error) {
            console.log("Error loading data types: " + error);
        })
    };

    const getInputTypes = function() {
        FormService.getInputTypes($scope.contentTypeId).then(function(data) {
            $scope.inputTypesList = data;
            let inputTypes = [];
            $scope.inputTypes = [];
            _.each(data, function(label, key) {
                inputTypes.push({key: key, label: label});
            });
            inputTypes = _.sortBy(inputTypes, 'label');
            _.each(inputTypes, function(inputType) {
                if (isNaN(inputType.label.charAt(0))) {
                    $scope.inputTypes.push(inputType);
                }
            });
            _.each(inputTypes, function(inputType) {
                if (!isNaN(inputType.label.charAt(0))) {
                    $scope.inputTypes.push(inputType);
                }
            });
        }, function(error) {
            console.log("Error loading input types: " + error);
        })
    };

    const getGoalAssociationTypes = function() {
        FormService.getGoalAssociationTypes().then(function(data) {
            $scope.goalAssociationsTypes = _.orderBy(JSON.parse(data.goalFields), 'displayName');
        }, function(error) {
            console.log("Error loading goal association types: "+ error);
        })
    }

    function getRollupFieldNames() {
        // For flights, the rollup targets are at the product/line item level
        FormService.getProductRollupTargets($scope.productId).then(function(fieldNames) {
            $scope.rollupTargetFieldNames = fieldNames.sort();
        }, function(error) {
            console.log("Error loading product rollup targets: " + error);
        });
    }

    function getWorkflowActions() {
        WorkflowsService.getWorkflowActions(true).then(function(data) {
            $scope.workflowActions = data;
        }, function() {
            console.log("Error fetching workflow actions.");
        });
    }

    let fieldsHelper = function() {
        $scope.calculateFields = [];
        $scope.hasCalculateFields = false;
        $scope.hasDistributedFields = false;
        $scope.hasFormulaErrors = false;
        $scope.formulaData = [];
        for (let i = 0, len = $scope.fieldsList.length; i < len; i++) {
            $scope.fieldsList[i].display_order = parseInt($scope.fieldsList[i].display_order);
            for (let j = 0, size = $scope.fieldsList.length; j < size; j++) {
                if ($scope.inputTypesList && $scope.inputTypesList[$scope.fieldsList[i].input_type]) {
                    $scope.fieldsList[i].input_type_name = $scope.inputTypesList[$scope.fieldsList[i].input_type];
                } else {
                    $scope.fieldsList[i].input_type_name = $scope.fieldsList[i].input_type;
                }
                if ($scope.fieldsList[i].parent_id && $scope.fieldsList[j].id == $scope.fieldsList[i].parent_id) {
                    $scope.fieldsList[i].parent_name = $scope.fieldsList[j].field_name;
                    break;
                }
            }
            if (($scope.fieldsList[i].input_type == 'calculated' || $scope.fieldsList[i].input_type == 'calculated-override') &&
                $scope.fieldsList[i].formula && $scope.fieldsList[i].active == '1') {
                $scope.calculateFields.push($scope.fieldsList[i]);
                $scope.hasCalculateFields = true;
                if ($scope.fieldsList[i].__FORMULA_ERROR__) {
                    $scope.hasFormulaErrors = true;
                }
                const formulaObj = {
                    id: $scope.fieldsList[i].id,
                    name: $scope.fieldsList[i].field_name,
                    formula: $scope.fieldsList[i].formula,
                    error: $scope.fieldsList[i].__FORMULA_ERROR__ ? $scope.fieldsList[i].__FORMULA_ERROR__ : ''
                };
                $scope.formulaData.push(formulaObj);
            }
            if ($scope.fieldsList[i].input_type == 'distributed-target') {
                $scope.hasDistributedFields = true;
            }
            if ($scope.fieldsList[i].custom_edit_action_id && $scope.fieldsList[i].custom_edit_action_id > 0) {
                const wfAction = _.find($scope.workflowActions, {id: $scope.fieldsList[i].custom_edit_action_id});
                if (wfAction) {
                    $scope.fieldsList[i].custom_edit_action_name = wfAction.name;
                } else {
                    $scope.fieldsList[i].custom_edit_action_name = '(not found)';
                }
            }
        }
        $scope.fieldsList = _.orderBy($scope.fieldsList, 'display_order');
        if ($scope.hasDistributedFields) {
            loadProductFields();  // Lazy loading of product fields... only load if necessary.
        }
    }

    $scope.showFormulaErrors = function() {
        $modal.open(
            ModalService.returnModalType('showFormulaErrors', {
                data: {
                    formulaErrors: $scope.formulaData
                }
            })
        );
    }

    const filterGroupFlightFields = function(groupId) {
        $scope.flightFieldObj[groupId] = [];
        _.each($scope.fieldsList, function(flightField) {
          if (groupId == flightField.group_id && flightField.active == '1') {
                $scope.flightFieldObj[groupId].push(flightField);
          }
          if (!$scope.showSynchronized && flightField.__new_ui_flight_form_field_id) {
            $scope.showSynchronized = true;
          }
        });
    }

    $scope.toggleInformationBeingDisplayed = function() {
        $scope.isExpandCollapseButtonDisabled = true;
        let isExpandingAllGroups = $scope.willExpandAllGroups;
        $scope.willExpandAllGroups = !$scope.willExpandAllGroups;
        $timeout(function () {
            if (isExpandingAllGroups) {
                $('span[data-toggle-display="expand"]').click();
            } else {
                $('span[data-toggle-display="collapse"]').click();
            }
        }, 0);
        $timeout(function () {
            $scope.isExpandCollapseButtonDisabled = false;
        }, 900);
    }

    // Toggle flight fields for a flight group
    $scope.toggleGroup = function(ev, group) {
        if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
            $(ev.target).parent().parent().siblings().children().last().show(900);
            $(ev.target).removeClass('fa-chevron-right');
            $(ev.target).addClass('fa-chevron-down');
            $(ev.target).attr('data-toggle-display', 'collapse');
            afterExpandingGroup();
            $scope.flightFieldObj[group.id] = [];
            $scope.productFilterObj[group.id] = "1";
            $scope.sortableDragIconShowHide[group.id] = "1";
            fieldsHelper();
            filterGroupFlightFields(group.id);
            $scope.fieldsHeader[group.id] = angular.copy($scope.fieldsTableData);
            $scope.tbsortableOptions[group.id] = {
                handle: '.ui-sorting-handle',
                axis: "y",
                containment: ".product-content-" + group.id,
                helper: function (e, tr) {
                    const $originals = tr.children();
                    const $helper = tr.clone();
                    $helper.children().each(function (index) {
                        // Set helper cell sizes to match the original sizes
                        $(this).width($originals.eq(index).width());
                    });
                    return $helper;
                },
                stop: function (e, ui) {
                    const groupId = $(ui.item).attr('group-id');
                    let fields = [];
                    let displayOrderCnt = 1;
                    _.each($scope.flightFieldObj[groupId], function (element, index) {
                        element.originalDisplayOrder = element.display_order;
                        element.display_order = displayOrderCnt++;
                        if ((element.originalDisplayOrder !== element.display_order)) {
                            fields.push({
                                id: element.id,
                                displayOrder: element.display_order
                            });
                        }
                    });
                    if (fields.length > 0) {
                        FormService.updateFormListDisplayOrder(fields).then(function(fieldsData) {
                            if (fieldsData) {
                                _.each(fieldsData, function(fieldObj){
                                    const groupField = _.find($scope.flightFieldObj[groupId], {id: fieldObj.id});
                                    if (groupField) {
                                        groupField.display_order = parseInt(fieldObj.display_order);
                                    }
                                    const flightField = _.find($scope.formFields, {id: fieldObj.id});
                                    if (flightField) {
                                        flightField.display_order = parseInt(fieldObj.display_order);
                                    }
                                });
                                $ioAlert.show('', 'Flight fields display order updated successfully', 'success');
                            }
                        }, function(error) {
                            console.log("Error updating display order: " + error);
                        });
                    }
                }
            }
        } else {
            $(ev.target).parent().parent().siblings().children().last().hide(600);
            $(ev.target).removeClass('fa-chevron-down');
            $(ev.target).addClass('fa-chevron-right');
            $(ev.target).attr('data-toggle-display', 'expand');
            afterCollapsingGroup();
        }
    };

    function afterExpandingGroup() {
        let count = $('span[data-toggle-display="expand"]').length;
        if (count === 0) {
            $scope.willExpandAllGroups = false;
        }
    }

    function afterCollapsingGroup() {
        let count = $('span[data-toggle-display="collapse"]').length;
        if (count === 0) {
            $scope.willExpandAllGroups = true;
        }
    }

    $scope.selectAll = function(groupId) {
        for (let i = 0, len = $scope.fieldsHeader[groupId].length; i < len; i++) {
            $scope.fieldsHeader[groupId][i].id = true;
        }
    }

    $scope.filterActiveColumn = function(groupId) {
        $scope.showActive = ! $scope.showActive;
        if ($scope.showActive) {
            $scope.productFilterObj[groupId] = "1"
            $scope.sortableDragIconShowHide[groupId] = "1";
        } else {
            $scope.productFilterObj[groupId] = "";
            $scope.sortableDragIconShowHide[groupId] = "";
        }
    };

    $scope.addGroup = function() {
        let param = {};
        param.groupName = "GROUP";
        param.active = 1;
        param.formId = $scope.flightFormId;
        if ( $scope.flightGroups &&  $scope.flightGroups.length) {
            param.groupDisplayOrder = Math.max.apply(Math,  $scope.flightGroups.map(function(o) {
                return parseInt(o.group_display_order);
            })) + 1;
        } else {
            param.groupDisplayOrder = 1;
        }

        FormService.saveFormFieldGroups(param).then(function(data) {
            if (data?.id) {
                data.active = data.active == '1';
                $scope.flightGroups.push(data);
                $ioAlert.show('', 'Group Added successfully', 'success');
            }
            updateDisplayGroups();
            $scope.productsLoader = false;
        }, function(error) {
            console.log(error);
            $ioAlert.show('Error!', JSON.stringify(error), 'error');
            $scope.productsLoader = false;
        });
    };

    $scope.deleteGroup = function(groupId) {
        $confirm.open({
            size: 'sm',
            text: 'Are you sure you want to delete this flight form field group?'
        }).then(function() {
            FormService.deleteFormFieldGroup(groupId).then(function() {
                getFlightFieldGroups();
                $ioAlert.show('Product Group deleted', 'Flight form field group has been successfully deleted', 'success');
            }, function(error) {
                console.log("error deleting TapIO flight form field group");
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }, function() {})
    };

    /*
    * Handle modal close
    */
    $scope.hideFieldForm = function() {
        let myElement = angular.element( document.querySelector( '#fieldForm' ) );
        myElement.addClass('fieldFormInactive');
        $timeout(function () {
            $scope.modalShown = false;
        }, 1000);
    }

    /*
    * Handle showing sliding box for add and edit flight field
    */
    $scope.showFieldForm = function(group, field, is_copy = false) {
        $scope.modalShown = true;
        $scope.currentGroup = group;
        $scope.fieldsObj = {
            "groupId": $scope.currentGroup.id,
            "displayOrder": $scope.currentGroup.group_display_order,
            "isEditable": "enable"
        };
        $scope.groupName = $scope.currentGroup.group_name;
        $scope.isNew = true;
        $scope.disableDisplayOrder = false;
        $scope.fieldHeaderName ="Add Field";
        $location.hash('field-body');
        anchorSmoothScroll.scrollTo('field-body');
        $timeout(function () {
            $location.hash('');
        }, 3000);
        if (field) {
            $scope.isNew = is_copy;
            $scope.disableDisplayOrder = true;
            if (!is_copy) {
                $scope.fieldHeaderName ="Update Field";
            } else {
                $scope.fieldHeaderName ="Copy Field #" + field.id + " As New Field";
            }
            formatObj(field, is_copy);
            if (field && field.parent_id) {
                $scope.checkLookup(field);
            }
        } else {
            $scope.fieldsObj.active = true;
            if (!_.isEmpty(highlightedField)) {
                $scope.fieldsObj.displayOrder = highlightedField.display_order + 1;
            }
            else if ($scope.flightFieldObj[group.id] && $scope.flightFieldObj[group.id].length) {
                $scope.fieldsObj.displayOrder = Math.max.apply(Math, $scope.flightFieldObj[group.id].map(function(o) {
                    return parseInt(o.display_order);
                })) + 5;
            }
            else {
                $scope.fieldsObj.displayOrder = 0;
            }
        }
    };

    $scope.addFieldHighlight = function (groupId, fieldIndex, field) {  // function that sets the value of selectedRow to current index
        _.each($scope.flightGroups, function (element) {
            if (element.id == groupId) {
                _.each($scope.flightFieldObj[element.id], function (fieldObj) {
                    if (fieldObj.id == field.id) {
                        highlightedField = (highlightedField && fieldObj.id == field.id) ? {} : field;
                        $scope.selectedRow = ($scope.selectedRow == fieldIndex) ? null : fieldIndex;
                        $scope.grouprow = element.id;
                    }
                });
            }
        });
    }

    /*
     * Handle save and edit Form list fields
     */
    $scope.addField = function (formObj, fieldsForm) {
        if (!fieldsForm.$valid) {
            $ioAlert.show('', 'Please fill the required fields', 'error');
            return
        }

        if (!formObj.fieldName.match(/^[a-zA-Z0-9_]+$/)) {
            $ioAlert.show('Error', 'Field Name allows Alpha Numeric Characters and Underscores ( _ ) only', 'error');
            return
        }

        if(formObj.fieldName.length > FIELD_MAX_LENGTH) {
            const message = 'Field Name length should be less than ' + FIELD_MAX_LENGTH + ' characters'
            $ioAlert.show('Error', message, 'error');
            return
        }

        if ((formObj.inputType === 'calculated' || formObj.inputType === 'calculated-override') && !formObj.formula) {
            $ioAlert.show('Error', `A ${formObj.inputType} field must have a formula`);
            return
        }

        let group = $scope.currentGroup; // Cannot be const in case we change the field's group
        let params = JSON.parse(JSON.stringify(formObj));
        params.formId = $scope.flightFormId;
        params.clusterId = ClusterService.clusterIds ? ClusterService.clusterIds[0] : 0;
        if (params.required == true) {
            params.required = 'yes'
        } else {
            params.required = 'no'
        }
        if (params.clearOnClone == true) {
            params.clearOnClone = 'yes'
        } else {
            params.clearOnClone = 'no'
        }
        if (params.gridShow == true) {
            params.gridShow = 'yes'
        } else {
            params.gridShow = 'no'
        }
        if (params.active == true) {
            params.active = 'yes'
        } else {
            params.active = 'no'
        }
        if (params.dashboardEnabled == true) {
            params.dashboardEnabled = "yes"
        } else {
            params.dashboardEnabled = "no"
        }
        if (params.hasDateRules == true) {
            params.hasDateRules = 1
        } else {
            params.hasDateRules = 0
        }
        if (params.showLongText == true) {
            params.showLongText = 1
        } else {
            params.showLongText = 0
        }
        if (params.dataType == 'date' && params.defaultValue) {
            const defaultValue = {
                dateOption: params.defaultValue,
                numDays: params.numDays,
                businessDay: params.businessDay,
            };
            params.defaultValue = JSON.stringify(defaultValue);
        } else if (params.inputType == 'multiselect' || params.inputType == 'multiselect-custom') {
            if (params.defaultValue && angular.isArray(params.defaultValue)) {
                params.defaultValue = JSON.stringify(params.defaultValue)
            } else {
                params.defaultValue = JSON.stringify([]);
            }
        } else if(params.defaultValue && !angular.isString(params.defaultValue)){
            params.defaultValue = JSON.stringify(params.defaultValue);
        }

        if ($scope.isNew) {
            if (params.hasDateRules) {
                params.updateDateRule = "yes";
                _.each($scope.fieldsList, function (fieldObj) {
                    if (fieldObj.field_name == 'start_date' || fieldObj.field_name == 'end_date') {
                        if (fieldObj.date_rules) {
                            params.dateRules = fieldObj.date_rules;
                        }
                    }
                })
            }
            FormService.saveFormFields(params).then(function (data) {
                if (data) {
                    if (!$scope.flightFieldObj[group.id]) {
                        $scope.flightFieldObj[group.id] = []
                    }
                    $scope.fieldsList.push(data);
                    filterGroupFlightFields(group.id);
                    fieldsHelper();
                    getFlightFields();
                    $scope.showForm = false;
                    $scope.modalShown = false;
                    $ioAlert.show('', 'Field Added successfully', 'success');
                }
            }, function (error) {
                console.log("Error saving flight field: " + error);
                $ioAlert.show('Error!', error, 'error');
            })
        } else {
            if (params.groupId && (params.groupId != group.id)) {
                params.displayOrder = FormService.computeHighestDisplayOrderInGroup($scope.fieldsList, params.groupId);
            }
            FormService.updateFormFields(params).then(function (formField) {
                if (formField) {
                    processUpdateFormFieldsSuccess(group, formField);
                }
                $scope.showForm = false;
                $scope.modalShown = false;
            }, function (data) {
                // TODO eventually support data.requires_deletion when flights are supported in New O&W
                console.log("Error updating flight field: " + data.errors);
                $ioAlert.show('Error!', data.errors, 'error');
            })
        }
    }

    const processUpdateFormFieldsSuccess = function(group, formField) {
        const formFieldIndex = _.findIndex($scope.fieldsList, {id: formField.id});
        if (formFieldIndex>=0) {
            $scope.fieldsList[formFieldIndex] = formField;
        }
        fieldsHelper();
        filterGroupFlightFields(formField.group_id);
        if (formField.group_id != group.id) {
            filterGroupFlightFields(group.id) // If it was moved to another group, filter the old group too
            // And if it was moved, we need to recompute both groups' can_be_deleted attribute to correctly
            // display the trash can icon that allows deleting the group.
            group.can_be_deleted = FormService.groupCanBeDeleted(group.id, $scope.fieldsList);
            let newGroup = _.find($scope.flightGroups, {id: formField.group_id});
            if (newGroup) {
                newGroup.can_be_deleted = FormService.groupCanBeDeleted(formField.group_id, $scope.fieldsList);
            }
        }
        $ioAlert.show('', 'Field Updated successfully', 'success');
    };

        /*
        *    Get lookup content for selected input type
        */
    $scope.getLookupContent = function(resetDefaultVal = false) {
        if ($scope.fieldsObj.inputType == 'checkbox') {
            $scope.defaultLookupContents = [
                {name:'Yes', value: 1},
                {name:'No', value: 0},
            ];
            return;
        }
        if ($scope.fieldsObj.lookupTypeId) {
            if(resetDefaultVal && $scope.fieldsObj.inputType == 'multiselect' && $scope.fieldsObj.inputType == 'multiselect-custom') {
                $scope.fieldsObj.defaultValue = [];
            }
            $scope.clusterId = ClusterService.clusterIds[0];
            ProductService.getLookupContent($scope.fieldsObj.lookupTypeId, $scope.clusterId).then(function() {
                $scope.defaultLookupContents = ProductService.lookupContents;
                $scope.defaultLookupContents.forEach(lookupContent => {
                    if (lookupContent.parent_name && lookupContent.parent_name.length > 0) {
                        lookupContent.lookup_value = lookupContent.lookup_value + 
                        ' <- ' + lookupContent.parent_name;
                    }
                });
            }, function() {
                console.log("error loading lookup contents for lookup type Id: ");
            });
        }
    }

    /*
    *    Handle formatting the flight fields object
    */
    const formatObj = function(obj, is_copy = false) {
        const keys = Object.keys(obj);
        let prev_field_id = $scope.fieldsObj.id;
        for (let i = 0, len = keys.length; i < len; i++) {
            switch (keys[i]) {
                case 'id':
                    $scope.fieldsObj.id = obj[keys[i]];
                    break;
                case 'data_type':
                    $scope.fieldsObj.dataType = obj[keys[i]];
                    break;
                case 'field_name':
                    if (is_copy) {
                        $scope.fieldsObj.fieldName = obj[keys[i]] + "_copy";
                    } else {
                        $scope.fieldsObj.fieldName = obj[keys[i]];
                    }
                    break;
                case 'display_name':
                    if (is_copy) {
                        $scope.fieldsObj.displayName = obj[keys[i]] + " (Copy)";
                    } else {
                        $scope.fieldsObj.displayName = obj[keys[i]];
                    }
                    break;
                case 'input_type':
                    $scope.fieldsObj.inputType = obj[keys[i]];
                    break;
                case 'is_editable':
                    $scope.fieldsObj.isEditable = (obj[keys[i]])?obj[keys[i]]:'enable';
                    break;
                case 'parent_id':
                    $scope.fieldsObj.parentId = obj[keys[i]];
                    break;
                case 'parent_trigger_id':
                    $scope.fieldsObj.parentTriggerId = obj[keys[i]];
                    break;
                case 'lookup_type_id':
                    $scope.fieldsObj.lookupTypeId = obj[keys[i]];
                    break;
                case 'required':
                    $scope.fieldsObj.required = (obj[keys[i]] == 1);
                    break;
                case 'clear_on_clone':
                    $scope.fieldsObj.clearOnClone = (obj[keys[i]] == 1);
                    break;
                case 'cascading_field_name':
                    $scope.fieldsObj.cascadingFieldName = obj[keys[i]];
                    break;
                case 'display_order':
                    $scope.fieldsObj.displayOrder = parseInt(obj[keys[i]]);
                    break;
                case 'active':
                    $scope.fieldsObj.active = (obj[keys[i]] == 1);
                    break;
                case 'show_long_text':
                    $scope.fieldsObj.showLongText = obj[keys[i]] == 1 ? true : false;
                    break;
                case 'enable_type_ahead':
                    $scope.fieldsObj.enableTypeAhead = obj[keys[i]] == 1 ? true : false;
                    break;
                case 'grid_show':
                    $scope.fieldsObj.gridShow = (obj[keys[i]] == 1);
                    break;
                case 'help_text':
                    $scope.fieldsObj.helpText = obj[keys[i]];
                    break;
                case 'formula':
                    $scope.fieldsObj.formula = obj[keys[i]];
                    break;
                case 'validation_rules':
                    $scope.fieldsObj.validationRules = obj[keys[i]];
                    break;
                case 'goal_association':
                    $scope.fieldsObj.goalAssociation = obj[keys[i]];
                    break;
                case 'rollup_field_name':
                    $scope.fieldsObj.rollupFieldName = obj[keys[i]];
                    break;
                case 'notes':
                    $scope.fieldsObj.notes = obj[keys[i]];
                    break;
                case 'distributed_source_product_field_id':
                    $scope.fieldsObj.distributedSourceProductFieldId = obj[keys[i]];
                    break;
                case 'distribution_type':
                    $scope.fieldsObj.distributionType = obj[keys[i]];
                    break;
                case 'custom_edit_action_id':
                    $scope.fieldsObj.customEditAction = obj[keys[i]];
                    break;
                case 'default_value':
                    let defaultValue = obj[keys[i]];
                    $scope.fieldsObj.defaultValue = defaultValue;
                    if (obj.data_type === "time" && defaultValue) {
                        if (defaultValue.indexOf(":")>0 && (defaultValue.indexOf(" AM")>0 || defaultValue.indexOf(" PM")>0)) {
                            let timeData = defaultValue.split(" ");
                            const ampm = timeData[1];
                            timeData = timeData[0].split(":");
                            timeData[0] = (ampm === "PM")?(parseInt(timeData[0]) + 12):parseInt(timeData[0]);
                            timeData[0] = (parseInt(timeData[0]) < 10)?"0"+parseInt(timeData[0]):parseInt(timeData[0]);
                            timeData[1] = (parseInt(timeData[1]) < 10)?"0"+parseInt(timeData[1]):parseInt(timeData[1]);
                            $scope.fieldsObj.timeEditor = timeData[0]+":"+timeData[1]+":00";
                        }
                    } else if (obj.data_type === 'date' && defaultValue) {
                        let params = '';
                        try {
                            params = JSON.parse(defaultValue);
                        } catch (e) {
                            params = 'string'
                        }
                        if ((typeof params) == 'object') {
                            $scope.fieldsObj.defaultValue = params.dateOption;
                            $scope.fieldsObj.numDays = params.numDays;
                            const offset = parseInt(params.numDays);
                            $scope.dateOffset = isNaN(offset) ? 0 : offset;
                            $scope.fieldsObj.businessDay = params.businessDay;
                        }
                    }
                    break;
                case 'dashboard_enabled':
                    $scope.fieldsObj.dashboardEnabled = (obj[keys[i]] == 1);
                    break;
                case 'has_date_rules':
                    $scope.fieldsObj.hasDateRules = obj[keys[i]] == '1' ? true : false;
                    break;
            }
        }
        if (prev_field_id != $scope.fieldsObj.id) {
            $scope.defaultValuePrevType = "";
        }
        $scope.checkType();
    };

    /*
    *    Handle properties of selected input types
    */
    $scope.checkType = function() {
        switch ($scope.fieldsObj.inputType) {
            case 'creative':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "file";
                break;
            case 'geo-location':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'geo-targeting-google':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'triton-geo-targeting':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'location-picker':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'location-picker-fb':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'location-targeting':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'snap-chat-age-targeting':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'google-ads-aud-targeting':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'DFP':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'day-parting':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'age-targeting':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'ad-schedule':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'metric-select':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'ad-group':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'google-ads-bidding':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'facebook-create-ads':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'shopping_adgroup_singleproduct':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'shopping_adgroup_multiproduct':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'dfp-frequency':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'devices':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'device-capability':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'dfp_ad_units':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'connection':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'mobile-app':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'service-mapper':
                $scope.isDisabled = true;
                $scope.fieldsObj.fieldName = "serviceMapper";
                $scope.isFieldNameDisable = true;
                $scope.fieldsObj.dataType = "string";
                break;
            case 'multiple-mappings':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'inventory-filter':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'checkbox':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "tinyint";
                break;
            case 'currency':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "currency";
                break;
            case 'percentage':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "percentage";
                break;
            case 'file':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "file";
                break;
            case 'custom_file':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "file";
                break;
            case 'emoji':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "string";
                break;
            case 'select':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "string";
                break;
            case 'select2':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "string";
                break;
            case 'multiselect':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "string";
                break;
            case 'multiselect-custom':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "string";
                break;
            case 'timeselect':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "time";
                break;
            case 'facebook-audience-targeting':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'facebook-audiences':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'snap-gender':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'advanced-demographics':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'snap-predefined-audiences':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'pinterest-audience-targeting':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'linkedin-audience-targeting':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'custom-macro-mapping':
            case 'custom-macro-mapping-2':
            case 'seed-list-macros':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'google-ads-extension':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'google-ads-extension':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'tiktok-audience-targeting':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'tiktok-device-targeting':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'bridge-email-test':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'pinterest-keyword':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'accountability-group-label':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'linkedin-campaign-objective':
                $scope.isDisabled = true;
                $scope.fieldsObj.dataType = "json";
                break;
            case 'distributed-target':
                $scope.isDisabled = false;
                $scope.isFieldNameDisable = false;
                loadProductFields();
                $scope.dataTypes = ['currency','integer'];
                // The following fields are not compatible with distributed-target: parent (and trigger), formula, cascading_field_name, lookup_type_id
                $scope.resetParentId();
                $scope.fieldsObj.parentTriggerId = undefined;
                $scope.fieldsObj.formula = null;
                $scope.fieldsObj.cascadingFieldName = null;
                $scope.fieldsObj.lookupTypeId = null
                break;
            default:
                $scope.isFieldNameDisable = false;
                $scope.isDisabled = false;
        }
        if ($scope.fieldsObj.inputType != 'distributed-target') {
            // Restore data types in case they previously were restricted by selecting distributed-target.
            $scope.dataTypes = $scope.allDataTypes;
            $scope.fieldsObj.distributionType = null;
            $scope.fieldsObj.distributedSourceProductFieldId = null;
        }
        if ($scope.fieldsObj.inputType == 'select' ||
            $scope.fieldsObj.inputType == 'multiselect' ||
            $scope.fieldsObj.inputType == 'multiselect-custom' ||
            $scope.fieldsObj.inputType == 'checkbox')
        {
            $scope.getLookupContent();
        }
        if ($scope.fieldsObj.inputType == 'select' && !angular.isString($scope.fieldsObj.defaultValue)) {
            $scope.fieldsObj.defaultValue = null;
        }
        if (FormService.inputTypesNoLookupType().includes($scope.fieldsObj.inputType)) {
            $scope.showLookupType = false;
        } else {
            $scope.showLookupType = true;
        }
        $scope.checkDataType();
    };

    /*
    *   Handle goal association type
    */
    $scope.changeGoalAssociationType = function() {
        switch($scope.fieldsObj.goalAssociation) {
            case 'name':
            case 'campaign_name':
            case 'column':
            case 'service_id':
            case 'smart_campaign_id':
                $scope.fieldsObj.dataType = 'string';
                $scope.isDisabled = true;
                break;
            case 'target':
                $scope.fieldsObj.dataType = 'decimal';
                $scope.isDisabled = true;
                break;
            case 'start':
            case 'end':
                $scope.fieldsObj.dataType = 'date';
                $scope.isDisabled = true;
                break;
            case 'customer_id':
                $scope.fieldsObj.dataType = 'integer';
                $scope.isDisabled = true;
                break;
            case 'threshold_1':
            case 'threshold_2':
                $scope.fieldsObj.dataType = 'tinyint';
                $scope.isDisabled = true;
                break;
        }
    }

    /*
    *    Handle checking the datatype and assigning related properties
    */
    $scope.checkDataType = function() {
        switch ($scope.fieldsObj.dataType) {
            case 'currency':
            case 'percentage':
            case 'decimal':
            case 'integer':
            case 'tinyint':
                $scope.fieldsObj.defaultValue = parseFloat($scope.fieldsObj.defaultValue);
                $scope.defaultValueDisabled = false;
                $scope.defaultValueType = 'number';
                $scope.defaultInputType = 'text';
                break;
            case 'date':
                $scope.defaultValueDisabled = false;
                $scope.defaultValueType = 'date';
                $scope.defaultInputType = 'date';
                break;
            case 'time':
                if ($scope.fieldsObj.defaultValue && typeof $scope.fieldsObj.defaultValue == "string") {
                    let dateVal = String($scope.fieldsObj.defaultValue);
                    let dateObj;
                    if (dateVal.indexOf("T")>=0) {
                        dateObj = new Date(dateVal);
                    } else {
                        dateVal = dateVal.split(":");
                        dateObj = new Date(0, 0, 0, parseInt(dateVal[0]), parseInt(dateVal[1]), 0);
                    }
                    $scope.fieldsObj.timeEditor = dateObj;
                }
                $scope.defaultValueDisabled = false;
                $scope.defaultValueType = 'time';
                $scope.defaultInputType = 'time';
                break;
            case 'hyperlink':
                $scope.fieldsObj.dataType = [
                    'text',
                    'calculated',
                    'calculated-override'
                ].includes($scope.fieldsObj.inputType) ?
                    'hyperlink' : 'string';
                // Do not need break here, we will continue using 'string'
            case 'string':
                $scope.defaultValueDisabled = false;
                $scope.defaultValueType = 'text';
                $scope.defaultInputType = 'text';
                break;
            default:
                $scope.defaultValueDisabled = true;
                $scope.defaultValueType = 'text';
                $scope.defaultInputType = 'text';
        }
        if (!['currency','decimal','integer','percentage'].includes($scope.fieldsObj.dataType)) {
            // Clear the rollup field name if the data type is incompatible with rolling up.
            $scope.fieldsObj.rollupFieldName = undefined;
        }
        if ($scope.defaultValuePrevType != "" && ($scope.defaultValuePrevType != $scope.defaultValueType || $scope.defaultValueDisabled === true)) {
            $scope.fieldsObj.defaultValue = '';
        }
        if ($scope.fieldsObj.inputType == 'select' || $scope.fieldsObj.inputType == 'multiselect' || $scope.fieldsObj.inputType == 'multiselect-custom') {
            $scope.defaultInputType = $scope.fieldsObj.inputType;
            if (($scope.fieldsObj.inputType == 'multiselect' || $scope.fieldsObj.inputType == 'multiselect-custom') &&
                $scope.fieldsObj.defaultValue && !angular.isArray($scope.fieldsObj.defaultValue)) {
                $scope.fieldsObj.defaultValue = JSON.parse($scope.fieldsObj.defaultValue);
            }
        } else if ($scope.fieldsObj.inputType == 'checkbox') {
            $scope.defaultInputType = $scope.fieldsObj.inputType;
        }
        $scope.defaultValuePrevType = $scope.defaultValueType;
    }

    /*
    *    Handle checking lookup contents
    */
    $scope.checkLookup = function(field) {
        $scope.lookupContents = [];
        for (let i = 0, len = $scope.fieldsList.length; i < len; i++) {
            if ($scope.fieldsObj.parentId == $scope.fieldsList[i].id) {
                $scope.showParentMultiSelect = ($scope.fieldsList[i].input_type == "checkbox") ? false : true;
                if ($scope.fieldsList[i].lookup_type_id) {
                    ProductService.getLookupContent($scope.fieldsList[i].lookup_type_id).then(function() {
                        $scope.lookupContents = ProductService.lookupContents;
                        $scope.lookupContents.forEach(lookupContent => {
                            if (lookupContent.parent_name && lookupContent.parent_name.length > 0) {
                                lookupContent.lookup_value = lookupContent.lookup_value + 
                                ' <- ' + lookupContent.parent_name;
                            }
                        });
                    }, function() {
                        console.log("Error loading lookup contents for lookup type Id: " + $scope.lookupId);
                    });
                } else if ($scope.fieldsList[i].input_type == "checkbox") {
                    $scope.lookupContents = [{
                        "id": "0",
                        "lookup_value": "No"
                    }, {
                        "id": "1",
                        "lookup_value": "Yes"
                    }];
                }
            }
        }
    };

    $scope.plusDateOption = function() {
        if ($scope.fieldsObj.defaultValue == undefined ||
            $scope.fieldsObj.defaultValue == '') {
            $scope.fieldsObj.defaultValue = 'Today';
        }
        $scope.dateOffset++;
        const operator = $scope.dateOffset > 0 ? '+':'';
        const offset = $scope.dateOffset == 0 ? '' : $scope.dateOffset;
        $scope.fieldsObj.numDays = operator + offset;
    }

    $scope.minusDateOption = function() {
        if ($scope.fieldsObj.defaultValue == undefined ||
            $scope.fieldsObj.defaultValue == '') {
            $scope.fieldsObj.defaultValue = 'Today';
        }
        $scope.dateOffset--;
        const operator = $scope.dateOffset > 0 ? '+':'';
        const offset = $scope.dateOffset == 0 ? '' : $scope.dateOffset;
        $scope.fieldsObj.numDays = operator + offset;
    }

    $scope.inputNumDays = function() {
        const offset = parseInt($scope.fieldsObj.numDays);
        $scope.dateOffset = isNaN(offset) ? 0 : offset;
    }

    $scope.clearDateOption = function() {
        $scope.fieldsObj.defaultValue = undefined;
        $scope.fieldsObj.numDays = undefined;
        $scope.dateOffset = 0;
    }

    $scope.$watch('fieldsObj.timeEditor', function() {
        if ($scope.fieldsObj?.timeEditor) {
            $scope.fieldsObj.defaultValue =
                String($filter('date')($scope.fieldsObj.timeEditor, "HH:mm")) + ":00";
        }
    });

    function showGroupModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, {
            data: data
        }));
    }

    /*
    *    Handle cancel the sliding box
    */
    $scope.cancelModal = function() {
        $scope.showForm = false;
        $scope.modalShown = false;
    }

    const loadProductFields = function() {
        if (!$scope.productFieldsLoaded) {
            $scope.productFieldsLoaded = true;
            ProductService.getProductFieldsForDisplay($scope.productId).then(function(productName) {
                if (ProductService.productFields) {
                    for (let i = 0, len = ProductService.productFields.length; i < len; i++) {
                        const field = ProductService.productFields[i];
                        if (field.active == 1 &&
                            (((field.input_type == 'text' || field.input_type == 'calculated' || field.input_type == 'calculated-override') && field.data_type == 'integer')) ||
                            ((field.input_type == 'currency' || field.input_type == 'calculated' || field.input_type == 'calculated-override') && field.data_type == 'currency')) {
                            const fieldData = {"label": field.field_name, "fieldId": field.id};
                            $scope.distributedSourceFields.push(fieldData);
                        }
                    }
                } else {
                    console.log("Cannot load product fields")
                }
            }, function(error) {
                console.log("Error loading product fields");
            });
        }
    }

    /*
    * Handle get instance lock configuration
    */
    const getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if (data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    const init = function() {
        if ($scope.productId) {
            ClusterService.initCluster($rootScope.userRole);
            getLookupTypes();
            getDataTypes();
            getInputTypes();
            getGoalAssociationTypes();
            getRollupFieldNames();
            getWorkflowActions();
            getHideConditionTypes();
            getInstanceLockConfig();
            getFlightFieldGroups();
            UserService.adjustStickyHeader();
        } else {
            $state.go('products');
        }
    };

    init();
    UserService.adjustStickyHeaderWindowResize();
}
